/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import authHeader from "./auth-header";
import http from "./http-common";
import { API_URLU } from "../config/constant";

const getUserById = (id) => {
  return axios.get(API_URLU + "user/" + id, { headers: authHeader() });
};

const getDaySales = (branch_code, collection_date, cmp_id) => {
  return axios.get(
    API_URLU +
    "day_sales/" +
    branch_code +
    "/" +
    collection_date +
    "/" +
    cmp_id,
    { headers: authHeader() }
  );
};

const getUserSales = (createdBy, status) => {
  return axios.get(API_URLU + "sales/" + createdBy + "/" + status, {
    headers: authHeader(),
  });
};

const getAllSales = (status) => {
  return axios.get(API_URLU + "sales/" + status, { headers: authHeader() });
};

const getPendingSales = (cmp_id, usr_id) => {
  return axios.get(API_URLU + "pending_sales/" + cmp_id + "/" + usr_id, {
    headers: authHeader(),
  });
};

const getApprovedSales = (cmp_id) => {
  return axios.get(API_URLU + "approved-sales/" + cmp_id, {
    headers: authHeader(),
  });
};

const getUserShops = (id) => {
  return axios.get(API_URLU + "user_shops/" + id, { headers: authHeader() });
};

const getAllShops = (id) => {
  return axios.get(API_URLU + "all_shops/" + id, { headers: authHeader() });
};

const getUsers = () => {
  return axios.get(API_URLU + "user", { headers: authHeader() });
};

const postUser = (data) => {
  return axios.post(API_URLU + "user", data, { headers: authHeader() });
};

const putUser = (id, data) => {
  return axios.patch(API_URLU + "user/" + id, data, { headers: authHeader() });
};

const getCompById = (id) => {
  return axios.get(API_URLU + "company/" + id, { headers: authHeader() });
};

const getCompanies = () => {
  return axios.get(API_URLU + "company", { headers: authHeader() });
};

const postComp = (data) => {
  return axios.post(API_URLU + "company", data, { headers: authHeader() });
};

const getSystemById = (id) => {
  return axios.get(API_URLU + "system" + id, { headers: authHeader() });
};

const getMaxDate = (cmpid, branch_code) => {
  return axios.get(API_URLU + "max-date/" + cmpid + "/" + branch_code, {
    headers: authHeader(),
  });
};

const getSaleStatus = (cmpid, branch_code) => {
  return axios.get(API_URLU + "sale-status/" + cmpid + "/" + branch_code, {
    headers: authHeader(),
  });
};

const getPastDays = (status) => {
  return axios.get(API_URLU + "open-days/" + status, { headers: authHeader() });
};

const getDaysStatus = () => {
  return axios.get(API_URLU + "check-days", { headers: authHeader() });
};

const getSystems = () => {
  return axios.get(API_URLU + "system", { headers: authHeader() });
};

const postSystem = (data) => {
  return axios.post(API_URLU + "system", data, { headers: authHeader() });
};

const postUserComp = (data) => {
  return axios.post(API_URLU + "ucompany", data, { headers: authHeader() });
};

// const getUserCompbk = (data) => {
//   return axios.get(API_URLU + 'ucompany/', data, { headers: authHeader() });
// };

const getUserComp = (id) => {
  return axios.get(API_URLU + "user-companies?userId=" + id, {
    headers: authHeader(),
  });
};

const postUserSystems = (data) => {
  return axios.post(API_URLU + "user-systems", data, { headers: authHeader() });
};

const getCompSystems = (id) => {
  return axios.get(API_URLU + "company-systems?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getUserCompSystems = () => {
  return axios.get(API_URLU + "user-company-systems", {
    headers: authHeader(),
  });
};

const getUserCompUSystems = () => {
  return axios.get(API_URLU + "user-company-usystems", {
    headers: authHeader(),
  });
};

const getCustomerById = (data) => {
  return axios.get(
    API_URLU +
    "customerCode?cmpId=" +
    data.cmpId +
    "&custCode=" +
    data.custCode,
    { headers: authHeader() }
  );
};

const getCustomerByCmpId = (data) => {
  return axios.get(
    API_URLU +
    "cmp_customer/" +
    data.id +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    { headers: authHeader() }
  );
};

const getCustomerByCmpIdAndId = (data) => {
  return axios.get(
    API_URLU +
    "cmp_customer-id/" +
    data.id +
    "/" +
    data.nationalId +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    {
      headers: authHeader(),
    }
  );
};

const getCustomerByCmpIdAndNid = (id, id1) => {
  return axios.get(API_URLU + "cmp_customer-nid/" + id + "/" + id1, {
    headers: authHeader(),
  });
};

const getCustomers = () => {
  return axios.get(API_URLU + "customer", { headers: authHeader() });
};

const postCustomer = (data) => {
  return axios.post(API_URLU + "customer", data, { headers: authHeader() });
};

const postSale = (data) => {
  return axios.post(API_URLU + "icr_sales", data, { headers: authHeader() });
};

const postDay = (data) => {
  return axios.post(API_URLU + "open-days", data, { headers: authHeader() });
};

const putSale = (id, data) => {
  return axios.put(API_URLU + "icr_sales/" + id, data, {
    headers: authHeader(),
  });
};

const putVatRate = (id, data) => {
  return axios.put(API_URLU + "vat-rates/" + id, data, {
    headers: authHeader(),
  });
};

const putStdRate = (id, data) => {
  return axios.put(API_URLU + "standard-rates/" + id, data, {
    headers: authHeader(),
  });
};

const putGenRate = (id, data) => {
  return axios.put(API_URLU + "general-rates/" + id, data, {
    headers: authHeader(),
  });
};

const putIstPeriod = (id, data) => {
  return axios.put(API_URLU + "ist-periods/" + id, data, {
    headers: authHeader(),
  });
};

const putIstSuppliers = (id, data) => {
  return axios.put(API_URLU + "ist-suppliers/" + id, data, {
    headers: authHeader(),
  });
};

const putDay = (id, data) => {
  return axios.put(API_URLU + "open-days/" + id, data, {
    headers: authHeader(),
  });
};

const getSalesByDate = (cmp_id, usr_id, sdate, edate) => {
  return axios.get(
    API_URLU +
    "sales_date/" +
    cmp_id +
    "/" +
    usr_id +
    "/" +
    sdate +
    "/" +
    edate,
    { headers: authHeader() }
  );
};

const getAdminSalesByDate = (cmp_id, sdate, edate) => {
  return axios.get(
    API_URLU + "admin-datesales/" + cmp_id + "/" + sdate + "/" + edate,
    { headers: authHeader() }
  );
};

const getSalesByShop = (cmp_id, branch_code, usr_id, first_date, last_date) => {
  return axios.get(
    API_URLU +
    "sales_shop/" +
    cmp_id +
    "/" +
    branch_code +
    "/" +
    usr_id +
    "/" +
    first_date +
    "/" +
    last_date,
    {
      headers: authHeader(),
    }
  );
};

const getAdminSalesByShop = (cmp_id, branch_code, first_date, last_date) => {
  return axios.get(
    API_URLU +
    "admin-shopsales/" +
    cmp_id +
    "/" +
    branch_code +
    "/" +
    first_date +
    "/" +
    last_date,
    {
      headers: authHeader(),
    }
  );
};

const delSale = (id) => {
  return axios.delete(API_URLU + "icr_sales/" + id, { headers: authHeader() });
};

const delVatRate = (id) => {
  return axios.delete(API_URLU + "vat-rates/" + id, { headers: authHeader() });
};

const delStdRate = (id) => {
  return axios.delete(API_URLU + "standard-rates/" + id, {
    headers: authHeader(),
  });
};

const delGenRate = (id) => {
  return axios.delete(API_URLU + "general-rates/" + id, {
    headers: authHeader(),
  });
};

const delIstProduct = (id) => {
  return axios.delete(API_URLU + "ist-products/" + id, {
    headers: authHeader(),
  });
};

const delCashRate = (id) => {
  return axios.delete(API_URLU + "ist-cashRates/" + id, {
    headers: authHeader(),
  });
};

const delMarkup = (id) => {
  return axios.delete(API_URLU + "ist-checkOffMarkup/" + id, {
    headers: authHeader(),
  });
};

const putCustomer = (data) => {
  return axios.put(API_URLU + "customer/" + data.custId, data, {
    headers: authHeader(),
  });
};

const getEmployeeById = (id) => {
  return axios.get(API_URLU + "chr_employee/" + id, { headers: authHeader() });
};

const getEmployeeByUsername = (name) => {
  return axios.get(API_URLU + "chr_by_username/" + name, {
    headers: authHeader(),
  });
};

const getEmployees = () => {
  return axios.get(API_URLU + "chr_employee", { headers: authHeader() });
};

const getPagedEmployees = (offset, pageSize) => {
  return axios.get(API_URLU + "employee/" + offset + "/" + pageSize, {
    headers: authHeader(),
  });
};

const postEmployee = (data) => {
  return axios.post(API_URLU + "employee", data, { headers: authHeader() });
};

const putEmployee = (id, data) => {
  return axios.put(API_URLU + "employee/" + id, data, {
    headers: authHeader(),
  });
};

const getClassification = () => {
  return axios.get(API_URLU + "classification", { headers: authHeader() });
};

const getGeneral = () => {
  return axios.get(API_URLU + "general", { headers: authHeader() });
};

const postTempBranch = (data) => {
  return axios.post(API_URLU + "tbranch", data, { headers: authHeader() });
};

const getTempBranch = () => {
  return axios.get(API_URLU + "tbranch", { headers: authHeader() });
};

const saveInvoice = (invoice) => {
  return axios.post(API_URLU + "SaveInvoice", invoice, {
    headers: authHeader(),
  });
};

const getInvoiceInfo = () => {
  return axios.get(API_URLU + "getInfo", { headers: authHeader() });
};

const getScheduledLeaves = () => {
  return axios.get(API_URLU + "scheduled_leaves", { headers: authHeader() });
};

const postLeaveSchedule = (data) => {
  return axios.post(API_URLU + "scheduled_leaves", data, {
    headers: authHeader(),
  });
};

const getLeaveAccruals = () => {
  return axios.get(API_URLU + "leave_accruals", { headers: authHeader() });
};

const getLeaveApplications = () => {
  return axios.get(API_URLU + "leave_applications", { headers: authHeader() });
};

const postLeaveApplication = (data) => {
  return axios.post(API_URLU + "leave_applications", data, {
    headers: authHeader(),
  });
};

const getLeaveTransactions = () => {
  return axios.get(API_URLU + "leave_transactions", { headers: authHeader() });
};

const getLeaveRejections = () => {
  return axios.get(API_URLU + "leave_rejections", { headers: authHeader() });
};

const getLeaveTypes = () => {
  return axios.get(API_URLU + "leave_types", { headers: authHeader() });
};

const getReturnDate = (data) => {
  return axios.get(
    API_URLU +
    "return_date?startDate=" +
    data.startDate +
    "&appliedDays=" +
    data.appliedDays +
    "&leaveCode=" +
    data.leaveCode +
    "&cmpId=" +
    data.cmpId,
    { headers: authHeader() }
  );
};

// const uploadFile = (file, onUploadProgress) => {
//   let formData = new FormData();

//   formData.append("file", file);
//   return axios.post(API_URLU + "singleUpload/", formData, { headers: authHeader(), onUploadProgress })}

// const getFiles = () => {
//   return axios.get(API_URLU + "files/", { headers: authHeader() })}

// const uploadFile = (file) => {
//   let formData = new FormData();

//   formData.append('file', file);

//   return http.post('/singleUpload', formData, {
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   });
// };

const uploadFile = (file) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/singleUpload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadBankReceipt = (file) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/saveReceipt", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadExcel = (file) => {
  let formData = new FormData();

  formData.append("file", file);

  return http.post("/upload_chr_employees", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const getFiles = () => {
  return http.get("/files");
};

const updatePass = (data) => {
  return axios.patch(API_URLU + "changepwd", data, { headers: authHeader() });
};

const updateUser = (data) => {
  return axios.get(
    API_URLU +
    "update-user-profile?id=" +
    data.id +
    "&longName=" +
    data.longName +
    "&email=" +
    data.email +
    "&phone=" +
    data.phone,
    { headers: authHeader() }
  );
};

const updateUserImg = (data) => {
  return axios.get(
    API_URLU + "update-user-image?id=" + data.id + "&photoUrl=" + data.photoUrl,
    { headers: authHeader() }
  );
};

const getStockCodes = (cmp_id) => {
  return axios.get(API_URLU + "supplier-products/" + cmp_id, {
    headers: authHeader(),
  });
};

const getCompanyProducts = (cmp_id) => {
  return axios.get(API_URLU + "company-istproducts/" + cmp_id, {
    headers: authHeader(),
  });
};

const getCompanySuppliers = (id) => {
  return axios.get(API_URLU + "company-istsuppliers/" + id, {
    headers: authHeader(),
  });
};

const getProductDetails = (id) => {
  return axios.get(API_URLU + "ist-products/" + id, { headers: authHeader() });
};

const getSupplierDetails = (id) => {
  return axios.get(API_URLU + "ist-suppliers/" + id, { headers: authHeader() });
};

const getSupplierDetailsByCmp = (id, supplierCode) => {
  return axios.get(
    API_URLU + "company-istsuppliers-bycmp/" + id + "/" + supplierCode,
    { headers: authHeader() }
  );
};

const getSupplerProductDetails = (id) => {
  return axios.get(API_URLU + "ist-supplierProducts/" + id, {
    headers: authHeader(),
  });
};

const getSupplierStocks = (supCode, cmpId) => {
  return axios.get(
    API_URLU + "company-istsupplierProducts/" + supCode + "/" + cmpId,
    { headers: authHeader() }
  );
};

const getCompanyStockCodes = (cmpId) => {
  return axios.get(API_URLU + "company-stockcodes/" + cmpId, {
    headers: authHeader(),
  });
};

const getCompanyStocks = (cmpId) => {
  return axios.get(API_URLU + "company-stocks/" + cmpId, {
    headers: authHeader(),
  });
};

const getQuoteId = (
  stockCode,
  pdate,
  cmpId,
  puser,
  cname,
  cphone,
  caddress,
  qtdId,
  quant
) => {
  return axios.get(
    API_URLU +
    "qtn_id?stockCode=" +
    stockCode +
    "&pdate=" +
    pdate +
    "&cmpId=" +
    cmpId +
    "&puser=" +
    puser +
    "&clientName=" +
    cname +
    "&clientPhone=" +
    cphone +
    "&clientAddress=" +
    caddress +
    "&qtdId=" +
    qtdId +
    "&quantity=" +
    quant,
    { headers: authHeader() }
  );
};

const genCombinedQuote = (qhdId, cmpId, pdate, puser) => {
  return axios.get(
    API_URLU +
    "gen-combinedQuote?qhdId=" +
    qhdId +
    "&cmpId=" +
    cmpId +
    "&pdate=" +
    pdate +
    "&user=" +
    puser,
    {
      headers: authHeader(),
    }
  );
};

const updateStockQuote = (stockCode, pdate, cmpId, puser) => {
  return axios.get(
    API_URLU +
    "update-quote?stockCode=" +
    stockCode +
    "&pdate=" +
    pdate +
    "&cmpId=" +
    cmpId +
    "&user=" +
    puser,
    {
      headers: authHeader(),
    }
  );
};

const updatePriceList = (stockCode, pdate, cmpId) => {
  return axios.get(
    API_URLU +
    "update-price?stockCode=" +
    stockCode +
    "&effDate=" +
    pdate +
    "&cmpId=" +
    cmpId,
    {
      headers: authHeader(),
    }
  );
};

const UpdateAllPrices = (pdate, cmpId) => {
  return axios.get(
    API_URLU + "update-price-all?effDate=" + pdate + "&cmpId=" + cmpId,
    {
      headers: authHeader(),
    }
  );
};

const inteGrateWithKct = (cmpId) => {
  return axios.get(API_URLU + "integrate-with-kct?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getQuoteReport = (
  quoteId,
  repFormat,
  companyName,
  clientName,
  clientPhone,
  clientAddress,
  code,
  sname,
  dateOfQuote,
  repName,
  quantity,
  totalCashPrice,
  phyLocation,
  postalAddress,
  town,
  telephone,
  quoteIdz
) => {
  return axios.get(
    API_URLU +
    "pricequote-report?qtnId=" +
    quoteId +
    "&reportFormat=" +
    repFormat +
    "&companyName=" +
    companyName +
    "&clientName=" +
    clientName +
    "&clientPhone=" +
    clientPhone +
    "&clientAddress=" +
    clientAddress +
    "&stockCode=" +
    code +
    "&stockName=" +
    sname +
    "&quoteDate=" +
    dateOfQuote +
    "&repName=" +
    repName +
    "&quantity=" +
    quantity +
    "&totalCashPrice=" +
    totalCashPrice +
    "&phyLocation=" +
    phyLocation +
    "&postalAddress=" +
    postalAddress +
    "&town=" +
    town +
    "&telephone=" +
    telephone +
    "&nonStockCode=" +
    quoteIdz,
    { headers: authHeader() }
  );
};

const getCombQuoteReport = (
  quoteId,
  repFormat,
  companyName,
  clientName,
  clientPhone,
  clientAddress,
  code,
  sname,
  dateOfQuote,
  repName,
  quantity,
  totalCashPrice,
  phyLocation,
  postalAddress,
  town,
  telephone,
  quoteIdz
) => {
  return axios.get(
    API_URLU +
    "pricequote-report?qtnId=" +
    quoteId +
    "&reportFormat=" +
    repFormat +
    "&companyName=" +
    companyName +
    "&clientName=" +
    clientName +
    "&clientPhone=" +
    clientPhone +
    "&clientAddress=" +
    clientAddress +
    "&stockCode=" +
    code +
    "&stockName=" +
    sname +
    "&quoteDate=" +
    dateOfQuote +
    "&repName=" +
    repName +
    "&quantity=" +
    quantity +
    "&totalCashPrice=" +
    totalCashPrice +
    "&phyLocation=" +
    phyLocation +
    "&postalAddress=" +
    postalAddress +
    "&town=" +
    town +
    "&telephone=" +
    telephone +
    "&nonStockCode=" +
    quoteIdz,
    { headers: authHeader() }
  );
};

const getQuoteInfo = (id) => {
  return axios.get(API_URLU + "price-quotation/" + id, {
    headers: authHeader(),
  });
};
const delQuote = (user, id) => {
  return axios.get(API_URLU + "archive-quote?user=" + user + "&qtnId=" + id, {
    headers: authHeader(),
  });
};

const closePeriod = (id) => {
  return axios.get(API_URLU + "close-period?periodId=" + id, {
    headers: authHeader(),
  });
};

const archCombQuote = (user, id) => {
  return axios.get(
    API_URLU + "archive-combQuote?user=" + user + "&qhdId=" + id,
    { headers: authHeader() }
  );
};

const postQuoteHeader = (data) => {
  return axios.post(API_URLU + "combined-quotation", data, {
    headers: authHeader(),
  });
};

const postQuoteDetails = (data) => {
  return axios.post(API_URLU + "quote-details", data, {
    headers: authHeader(),
  });
};

const postVatRates = (data) => {
  return axios.post(API_URLU + "vat-rates", data, { headers: authHeader() });
};

const postStandardRates = (data) => {
  return axios.post(API_URLU + "standard-rates", data, {
    headers: authHeader(),
  });
};

const postNewPeriod = (data) => {
  return axios.post(API_URLU + "ist-periods", data, { headers: authHeader() });
};

const postGeneralRates = (data) => {
  return axios.post(API_URLU + "general-rates", data, {
    headers: authHeader(),
  });
};

const postIstProducts = (data) => {
  return axios.post(API_URLU + "ist-products", data, { headers: authHeader() });
};

const postIstSuppliers = (data) => {
  return axios.post(API_URLU + "ist-suppliers", data, {
    headers: authHeader(),
  });
};

const putIstProducts = (id, data) => {
  return axios.put(API_URLU + "ist-products/" + id, data, {
    headers: authHeader(),
  });
};

const putIstSupplierProducts = (id, data) => {
  return axios.put(API_URLU + "ist-supplierProducts/" + id, data, {
    headers: authHeader(),
  });
};

const postIstSupplierProducts = (data) => {
  return axios.post(API_URLU + "ist-supplierProducts", data, {
    headers: authHeader(),
  });
};

const putCashRateDetails = (id, data) => {
  return axios.put(API_URLU + "ist-cashRates/" + id, data, {
    headers: authHeader(),
  });
};

const postCashRateDetails = (data) => {
  return axios.post(API_URLU + "ist-cashRates", data, {
    headers: authHeader(),
  });
};

const putHpDepositDetails = (id, data) => {
  return axios.put(API_URLU + "ist-hpdepositPercs/" + id, data, {
    headers: authHeader(),
  });
};

const postHpDepositDetails = (data) => {
  return axios.post(API_URLU + "ist-hpdepositPercs", data, {
    headers: authHeader(),
  });
};

const delHpDepositDetails = (id) => {
  return axios.delete(API_URLU + "ist-hpdepositPercs/" + id, {
    headers: authHeader(),
  });
};

const putMarkupDetails = (id, data) => {
  return axios.put(API_URLU + "ist-checkOffMarkup/" + id, data, {
    headers: authHeader(),
  });
};

const postMarkupDetails = (data) => {
  return axios.post(API_URLU + "ist-checkOffMarkup", data, {
    headers: authHeader(),
  });
};

const putDiscountDetails = (id, data) => {
  return axios.put(API_URLU + "ist-hpdiscounts/" + id, data, {
    headers: authHeader(),
  });
};

const postDiscountDetails = (data) => {
  return axios.post(API_URLU + "ist-hpdiscounts", data, {
    headers: authHeader(),
  });
};

const delDiscountDetails = (id) => {
  return axios.delete(API_URLU + "ist-hpdiscounts/" + id, {
    headers: authHeader(),
  });
};

const putInstalMonths = (id, data) => {
  return axios.put(API_URLU + "ist-instalmonths/" + id, data, {
    headers: authHeader(),
  });
};

const postInstalMonths = (data) => {
  return axios.post(API_URLU + "ist-instalmonths", data, {
    headers: authHeader(),
  });
};

const delInstalMonths = (id) => {
  return axios.delete(API_URLU + "ist-instalmonths/" + id, {
    headers: authHeader(),
  });
};

const putMarkupRates = (id, data) => {
  return axios.put(API_URLU + "ist-hpmarkuprates/" + id, data, {
    headers: authHeader(),
  });
};

const postMarkupRates = (data) => {
  return axios.post(API_URLU + "ist-hpmarkuprates", data, {
    headers: authHeader(),
  });
};

const delMarkupRate = (id) => {
  return axios.delete(API_URLU + "ist-hpmarkuprates/" + id, {
    headers: authHeader(),
  });
};

const putMarkupPercs = (id, data) => {
  return axios.put(API_URLU + "ist-hpmarkuppercs/" + id, data, {
    headers: authHeader(),
  });
};

const getCombinedQuotes = (qdtId) => {
  return axios.get(API_URLU + "get-combinedQuotes/" + qdtId, {
    headers: authHeader(),
  });
};

const listSingleQuoutes = () => {
  return axios.get(API_URLU + "list-singleQuotes", { headers: authHeader() });
};

const listCombinedQuoutes = (cmpId) => {
  return axios.get(API_URLU + "list-combinedQuotes/" + cmpId, {
    headers: authHeader(),
  });
};

const companyVatRates = (cmpId) => {
  return axios.get(API_URLU + "company-vats/" + cmpId, {
    headers: authHeader(),
  });
};

const companyStdRates = (cmpId) => {
  return axios.get(API_URLU + "company-standardRates/" + cmpId, {
    headers: authHeader(),
  });
};

const companyGenRates = (cmpId) => {
  return axios.get(API_URLU + "company-generalRates/" + cmpId, {
    headers: authHeader(),
  });
};
const currentPeriods = (cmpId) => {
  return axios.get(API_URLU + "company-currentperiods/" + cmpId, {
    headers: authHeader(),
  });
};
const pastPeriods = (cmpId) => {
  return axios.get(API_URLU + "company-pastperiods/" + cmpId, {
    headers: authHeader(),
  });
};

const allPeriods = (cmpId) => {
  return axios.get(API_URLU + "get-periods-vw?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const checkVatDates = (cmpId, startDate, endDate) => {
  return axios.get(
    API_URLU +
    "check-vatDates?cmpId=" +
    cmpId +
    "&startDate=" +
    startDate +
    "&endDate=" +
    endDate,
    {
      headers: authHeader(),
    }
  );
};

const getCombinedSingle = (stockCode) => {
  return axios.get(API_URLU + "combined-single?stockCode=" + stockCode, {
    headers: authHeader(),
  });
};

const getCompanyTariffPeriods = (cmpId) => {
  return axios.get(API_URLU + "tariff-periods?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getTariffCashRates = (trpId) => {
  return axios.get(API_URLU + "ist-trpCashRates/" + trpId, {
    headers: authHeader(),
  });
};

const getCheckOffMarkupPercs = (trpId) => {
  return axios.get(API_URLU + "ist-companyCheckOffMarkup/" + trpId, {
    headers: authHeader(),
  });
};

const getTrpDiscounts = (trpId) => {
  return axios.get(API_URLU + "ist-hpTrpdiscounts/" + trpId, {
    headers: authHeader(),
  });
};

const getTrpInstalMonths = (trpId) => {
  return axios.get(API_URLU + "ist-trpinstalmonths/" + trpId, {
    headers: authHeader(),
  });
};

const getHpMarkupRates = (trpId) => {
  return axios.get(API_URLU + "ist-trphpmarkuprates/" + trpId, {
    headers: authHeader(),
  });
};

const getHpMarkupPercs = (trpId) => {
  return axios.get(API_URLU + "ist-trphpmarkuppercs/" + trpId, {
    headers: authHeader(),
  });
};

const getDiscountDetails = (id) => {
  return axios.get(API_URLU + "ist-hpdiscounts/" + id, {
    headers: authHeader(),
  });
};

const getInstalMonthsDetails = (id) => {
  return axios.get(API_URLU + "ist-instalmonths/" + id, {
    headers: authHeader(),
  });
};

const getRateDetails = (id) => {
  return axios.get(API_URLU + "ist-cashRates/" + id, { headers: authHeader() });
};

const getHPDepositDetails = (id) => {
  return axios.get(API_URLU + "ist-hpdepositPercs/" + id, {
    headers: authHeader(),
  });
};

const getMarkupPercDetails = (id) => {
  return axios.get(API_URLU + "ist-checkOffMarkup/" + id, {
    headers: authHeader(),
  });
};

const closeTariffPeriod = (cmpId, pdate, user) => {
  return axios.get(
    API_URLU +
    "close-tariffperiod?cmpId=" +
    cmpId +
    "&pdate=" +
    pdate +
    "&user=" +
    user,
    { headers: authHeader() }
  );
};

const getTrpHpDeposit = (trpId) => {
  return axios.get(API_URLU + "ist-hpTrpdepositPercs/" + trpId, {
    headers: authHeader(),
  });
};

const getMarkupDetails = (rateId) => {
  return axios.get(API_URLU + "ist-hpmarkuprates/" + rateId, {
    headers: authHeader(),
  });
};

const getMarkupPerc = (rateId) => {
  return axios.get(API_URLU + "ist-hpmarkuppercs/" + rateId, {
    headers: authHeader(),
  });
};

const copyPeriods = (cmpId, trpId, pUser, pDate) => {
  return axios.get(
    API_URLU +
    "copy-periods?cmpId=" +
    cmpId +
    "&trpId=" +
    trpId +
    "&pUser=" +
    pUser +
    "&pDate=" +
    pDate,
    {
      headers: authHeader(),
    }
  );
};

const getProductHist = (id) => {
  return axios.get(API_URLU + "ist-productsHist/" + id, {
    headers: authHeader(),
  });
};

const getPriceCataloq = (data) => {
  return axios.get(
    API_URLU +
    "get-price-catalogue?periodYear=" +
    data.periodYear +
    "&cmpId=" +
    data.cmpId,
    { headers: authHeader() }
  );
};

const getStockCatalogue = (stockCode) => {
  return axios.get(API_URLU + "get-stock-catalog?stockCode=" + stockCode, {
    headers: authHeader(),
  });
};

const getCataloguePeriods = (cmpId) => {
  return axios.get(API_URLU + "get-catalog-periods/" + cmpId, {
    headers: authHeader(),
  });
};

const getJointYn = (stockCode, cmpId) => {
  return axios.get(
    API_URLU + "is-jointStock?stockCode=" + stockCode + "&cmpId=" + cmpId,
    { headers: authHeader() }
  );
};

const getJointStockCodes = (stockCode, cmpId) => {
  return axios.get(
    API_URLU + "joint-stocks?stockCode=" + stockCode + "&cmpId=" + cmpId,
    { headers: authHeader() }
  );
};

const getActiveStocks = (cmpId, pDate) => {
  return axios.get(
    API_URLU + "active-stocks?cmpId=" + cmpId + "&pDate=" + pDate,
    { headers: authHeader() }
  );
};

const getJointStocks = (cmpId, pDate, stockCode) => {
  return axios.get(
    API_URLU +
    "attach-joint-stocks?cmpId=" +
    cmpId +
    "&pDate=" +
    pDate +
    "&stockCode=" +
    stockCode,
    {
      headers: authHeader(),
    }
  );
};

const addJointStocks = (cmpId, jointStockCode, stockCode, pAction) => {
  return axios.get(
    API_URLU +
    "add-joint-stock?cmpId=" +
    cmpId +
    "&jointStockCode=" +
    jointStockCode +
    "&stockCode=" +
    stockCode +
    "&pAction=" +
    pAction,
    { headers: authHeader() }
  );
};

const getMinDate = (cmpId) => {
  return axios.get(API_URLU + "min-date?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getStockCheckOff = (stockCode) => {
  return axios.get(API_URLU + "stock-checkoff?stockCode=" + stockCode, {
    headers: authHeader(),
  });
};

const getSupplierPriceList = (cmpId, supCode) => {
  return axios.get(
    API_URLU + "supplier-price-list?cmpId=" + cmpId + "&supCode=" + supCode,
    { headers: authHeader() }
  );
};

const getSupplierPastPriceList = (cmpId, supCode, stockCode) => {
  return axios.get(
    API_URLU +
    "supplier-pastprice-list?cmpId=" +
    cmpId +
    "&supCode=" +
    supCode +
    "&stockCode=" +
    stockCode,
    {
      headers: authHeader(),
    }
  );
};

const updatePriceCatalogue = (data) => {
  return axios.get(
    API_URLU +
    "update-price-catalogue?periodYear=" +
    data.periodYear +
    "&periodMonth=" +
    data.periodMonth +
    "&pDate=" +
    data.pDate +
    "&cmpId=" +
    data.cmpId +
    "&username=" +
    data.username,
    {
      headers: authHeader(),
    }
  );
};

const addNewPriceListItem = (data) => {
  return axios.get(
    API_URLU +
    "add-new-stock-pricelist?cmpId=" +
    data.cmpId +
    "&stockCode=" +
    data.stockCode +
    "&pDate=" +
    data.pDate +
    "&combinedSingle=" +
    data.combinedSingle +
    "&pUser=" +
    data.pUser,
    {
      headers: authHeader(),
    }
  );
};

const getUserRights = (data) => {
  return axios.get(
    API_URLU +
    "userRights?sstId=" +
    data.sstId +
    "&username=" +
    data.username +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const approveVATRates = (data) => {
  return axios.get(
    API_URLU +
    "approve-vat?approvedYN=" +
    data.approvedYN +
    "&approvedBy=" +
    data.approvedBy +
    "&approvedDate=" +
    data.approvedDate +
    "&id=" +
    data.id,
    {
      headers: authHeader(),
    }
  );
};

const approveSTDRates = (data) => {
  return axios.get(
    API_URLU +
    "approve-std?approvedYN=" +
    data.approvedYN +
    "&approvedBy=" +
    data.approvedBy +
    "&approvedDate=" +
    data.approvedDate +
    "&id=" +
    data.id,
    {
      headers: authHeader(),
    }
  );
};

const approveGENRates = (data) => {
  return axios.get(
    API_URLU +
    "approve-gen?approvedYN=" +
    data.approvedYN +
    "&approvedBy=" +
    data.approvedBy +
    "&approvedDate=" +
    data.approvedDate +
    "&id=" +
    data.id,
    {
      headers: authHeader(),
    }
  );
};

const approvePeriod = (data) => {
  return axios.get(
    API_URLU +
    "approve-period?approvedYN=" +
    data.approvedYN +
    "&approvedBy=" +
    data.approvedBy +
    "&approvedDate=" +
    data.approvedDate +
    "&id=" +
    data.id,
    {
      headers: authHeader(),
    }
  );
};

const approveStock = (data) => {
  return axios.get(
    API_URLU +
    "approve-stock?approvedYN=" +
    data.approvedYN +
    "&approvedBy=" +
    data.approvedBy +
    "&approvedDate=" +
    data.approvedDate +
    "&id=" +
    data.id +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const clearStockPrices = (data) => {
  return axios.get(
    API_URLU +
    "clear-stock-prices?periodYear=" +
    data.periodY +
    "&periodMonth=" +
    data.periodM,
    {
      headers: authHeader(),
    }
  );
};

const updateStockPrices = (data) => {
  return axios.get(
    API_URLU +
    "update-stock-prices?cmpId=" +
    data.cmpId +
    "&periodYear=" +
    data.periodY +
    "&periodMonth=" +
    data.periodM,
    {
      headers: authHeader(),
    }
  );
};

const updateTariffPeriod = (data) => {
  return axios.get(
    API_URLU +
    "update-tariff-period?id=" +
    data.id +
    "&startdate=" +
    data.startdate +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const approvetariffPeriod = (data) => {
  return axios.get(
    API_URLU +
    "approve-tariff-period-proc?id=" +
    data.id +
    "&username=" +
    data.username +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const approveCashRate = (data) => {
  return axios.get(
    API_URLU + "approve-cashrate?rateId=" + data.id + "&pUser=" + data.username,
    {
      headers: authHeader(),
    }
  );
};

const approveCheckOff = (data) => {
  return axios.get(
    API_URLU + "approve-checkoff?rateId=" + data.id + "&pUser=" + data.username,
    {
      headers: authHeader(),
    }
  );
};

const genCombQuoteHeader = (data) => {
  return axios.get(
    API_URLU +
    "gen-comb-non-stock-header?cmpId=" +
    data.cmpId +
    "&supName=" +
    data.supName +
    "&user=" +
    data.user +
    "&quoteDate=" +
    data.quoteDate +
    "&weight=" +
    data.weight +
    "&solarPanel=" +
    data.solarPanel +
    "&solarComponent=" +
    data.solarComponent +
    "&discountPerc=" +
    data.discountPerc +
    "&stockName=" +
    data.stockName,
    {
      headers: authHeader(),
    }
  );
};
const genCombQuoteNoneStockDetails = (data) => {
  return axios.get(
    API_URLU +
    "gen-comb-non-stock-details?cmpId=" +
    data.cmpId +
    "&csqId=" +
    data.csqId +
    "&stockName=" +
    data.stockName +
    "&supplierPrice=" +
    data.supplierPrice +
    "&vatableYn=" +
    data.vatableYn +
    "&vatRate=" +
    data.vatRate +
    "&createdBy=" +
    data.createdBy,
    {
      headers: authHeader(),
    }
  );
};
const genNoneStockQuote = (data) => {
  return axios.get(
    API_URLU +
    "none-stock-quote?stockName=" +
    data.stockName +
    "&supplierName=" +
    data.supplierName +
    "&weight=" +
    data.weight +
    "&supplierPrice=" +
    data.supplierPrice +
    "&saleVatRate=" +
    data.saleVatRate +
    "&discountPerc=" +
    data.discountPerc +
    "&solarPanelYn=" +
    data.solarPanelYn +
    "&solarComponentYn=" +
    data.solarComponentYn +
    "&pDate=" +
    data.pDate +
    "&cmpId=" +
    data.cmpId +
    "&username=" +
    data.username,
    {
      headers: authHeader(),
    }
  );
};

const genCombNoneStockQuote = (data) => {
  return axios.get(
    API_URLU +
    "gen-comb-non-stock-quote?stockName=" +
    data.stockName +
    "&supplierName=" +
    data.supplierName +
    "&weight=" +
    data.weight +
    "&supplierPrice=" +
    data.supplierPrice +
    "&saleVatRate=" +
    data.saleVatRate +
    "&discountPerc=" +
    data.discountPerc +
    "&solarPanelYn=" +
    data.solarPanelYn +
    "&solarComponentYn=" +
    data.solarComponentYn +
    "&pDate=" +
    data.pDate +
    "&cmpId=" +
    data.cmpId +
    "&username=" +
    data.username +
    "&csqId=" +
    data.csqId,
    {
      headers: authHeader(),
    }
  );
};

const listNonStockQuotes = (id) => {
  return axios.get(API_URLU + "get-none-stock-quotes?nonStockCode=" + id, {
    headers: authHeader(),
  });
};

const listCombNonStockQuotes = (id) => {
  return axios.get(API_URLU + "get-comb-none-stock-quotes?csqId=" + id, {
    headers: authHeader(),
  });
};

const getActiveEndDate = (cmpId) => {
  return axios.get(API_URLU + "active_enddate?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getMenuLevels = (data) => {
  return axios.get(
    API_URLU +
    "get-menusbk?sstId=" +
    data.sstId +
    "&accessId=" +
    data.accessId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getAddTempItem = (id) => {
  return axios.get(API_URLU + "add-temp-stock?stockCode=" + id, {
    headers: authHeader(),
  });
};

const getPoH = () => {
  return axios.get(API_URLU + "po-headers", { headers: authHeader() });
};

const getPoHVW = (data) => {
  return axios.get(
    API_URLU +
    "po-headervw?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&approvalStatus=" +
    data.approvalStatus,
    {
      headers: authHeader(),
    }
  );
};

const getPoHBalnce = (data) => {
  return axios.get(
    API_URLU +
    "po-balance?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&supplierCode=" +
    data.supplierCode,
    {
      headers: authHeader(),
    }
  );
};

const getReqH = (data) => {
  return axios.get(
    API_URLU + "req-headersvw?userId=" + data.userId + "&cmpId=" + data.cmpId,
    { headers: authHeader() }
  );
};

const getPoDetails = (id) => {
  return axios.get(API_URLU + "po-details-vw?phdId=" + id, {
    headers: authHeader(),
  });
};

const getPoD = (id) => {
  return axios.get(API_URLU + "po-details-phdId?phdId=" + id, {
    headers: authHeader(),
  });
};

const getReqD = (id) => {
  return axios.get(API_URLU + "req-details-vw?rqhId=" + id, {
    headers: authHeader(),
  });
};

const getPolNo = (data) => {
  return axios.get(
    API_URLU +
    "getPolnumber?cmpId=" +
    data.cmpId +
    "&transType=" +
    data.transType +
    "&branchCode=" +
    data.branchCode +
    "&transDate=" +
    data.transDate,
    { headers: authHeader() }
  );
};

const postPoH = (data) => {
  return axios.post(API_URLU + "po-headers", data, { headers: authHeader() });
};

const postPoD = (data) => {
  return axios.post(API_URLU + "po-details", data, { headers: authHeader() });
};

const getReqSummary = (data) => {
  return axios.get(
    API_URLU +
    "requisitions-req-summary/" +
    data.year +
    "/" +
    data.usrId +
    "/" +
    data.cmpId,
    { headers: authHeader() }
  );
};

const getPoSummary = (data) => {
  return axios.get(API_URLU + "po-summary/" + data.year + "/" + data.usrId, {
    headers: authHeader(),
  });
};

const getPohApproval = (data) => {
  return axios.get(
    API_URLU +
    "approve-poh?username=" +
    data.username +
    "&approvedDate=" +
    data.approvedDate +
    "&phdId=" +
    data.phdId +
    "&cmpId=" +
    data.cmpId +
    "&approvalStatus=" +
    data.approvalStatus,
    { headers: authHeader() }
  );
};

const updateMialSent = (data) => {
  return axios.get(
    API_URLU + "approve-poh-mail?phdId=" + data.phdId + "&cmpId=" + data.cmpId,
    { headers: authHeader() }
  );
};

const cancelPO = (data) => {
  return axios.get(
    API_URLU +
    "cancel-poh?phdId=" +
    data.phdId +
    "&cmpId=" +
    data.cmpId +
    "&cancellationReason=" +
    data.cancellationReason +
    "&username=" +
    data.username +
    "&cancelledDate=" +
    data.cancelledDate,
    { headers: authHeader() }
  );
};

const getPurchaseReport = (data) => {
  return axios.get(
    API_URLU +
    "purchase-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&cmpId=" +
    data.cmpId +
    "&phdId=" +
    data.phdId +
    "&approvedBy=" +
    data.approvedBy +
    "&vendor=" +
    data.vendor +
    "&poNumber=" +
    data.poNumber +
    "&poDate=" +
    data.poDate +
    "&shop=" +
    data.shop +
    "&dispatchCode=" +
    data.dispatchCode +
    "&signUrl=" +
    data.signUrl +
    "&oldOrderNumber=" +
    data.oldOrderNumber,
    {
      headers: authHeader(),
    }
  );
};

const getCertReport = (data) => {
  return axios.get(
    API_URLU +
    "purchase-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&cmpId=" +
    data.cmpId +
    "&custCode=" +
    data.custCode +
    "&hpId=" +
    data.hpId +
    "&hpNumber=" +
    data.hpNumber +
    "&currDate=" +
    data.currDate +
    "&username=" +
    data.username +
    "&dueDate=" +
    data.dueDate,
    {
      headers: authHeader(),
    }
  );
};

const postGaaH = (data) => {
  return axios.post(API_URLU + "gaa-headers", data, { headers: authHeader() });
};

const postGaaD = (data) => {
  return axios.post(API_URLU + "gaa-details", data, { headers: authHeader() });
};

const getGaaDByGaaNo = (id) => {
  return axios.get(API_URLU + "gaa-details-gaaNo?gaaNo=" + id, {
    headers: authHeader(),
  });
};

const getUpdatePoDetails = (data) => {
  return axios.get(
    API_URLU +
    "approve-pod?rqdId=" +
    data.rqdId +
    "&cmpId=" +
    data.cmpId +
    "&quantityApproved=" +
    data.quantityApproved +
    "&approvalComments=" +
    data.approvalComments +
    "&approvalStatus=" +
    data.approvalStatus +
    "&username=" +
    data.username +
    "&approvedDate=" +
    data.approvedDate,
    {
      headers: authHeader(),
    }
  );
};

const getPoNotInGaa = (data) => {
  return axios.get(
    API_URLU +
    "po-notin-gaa-headervw?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&approvalStatus=" +
    data.approvalStatus,
    {
      headers: authHeader(),
    }
  );
};

const getGaaHVW = (data) => {
  return axios.get(
    API_URLU + "gaa-headervw?cmpId=" + data.cmpId + "&userId=" + data.userId,
    {
      headers: authHeader(),
    }
  );
};

const getGaaHVWItems = (data) => {
  return axios.get(
    API_URLU +
    "gaa-headervw-items?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&phdId=" +
    data.phdId,
    {
      headers: authHeader(),
    }
  );
};

const getGapByGaadNo = (gaadNo) => {
  return axios.get(API_URLU + "gaa-particulars-gaadNo?gaadNo=" + gaadNo, {
    headers: authHeader(),
  });
};

const getUserBranches = (id, id2) => {
  return axios.get(
    API_URLU + "get-user_branches?cmpId=" + id + "&userId=" + id2,
    {
      headers: authHeader(),
    }
  );
};

const postGap = (data) => {
  return axios.post(API_URLU + "gaa-particulars", data, {
    headers: authHeader(),
  });
};

const getGapItemsByGaaNo = (id) => {
  return axios.get(API_URLU + "gaa-particulars-gaaNo?gaaNo=" + id, {
    headers: authHeader(),
  });
};

const postStkTransH = (data) => {
  return axios.post(API_URLU + "asset-tran-headers", data, {
    headers: authHeader(),
  });
};

const postStkTransD = (data) => {
  return axios.post(API_URLU + "asset-tran-details", data, {
    headers: authHeader(),
  });
};

const generateCombinedNonStockQuote = (csqId, user) => {
  return axios.get(
    API_URLU +
    "generate-combined-nonstock-quote?csqId=" +
    csqId +
    "&user=" +
    user,
    { headers: authHeader() }
  );
};

const getShopTransfers = (data) => {
  return axios.get(
    API_URLU +
    "shop-trans-headervw?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&approvalStatus=" +
    data.approvalStatus,
    {
      headers: authHeader(),
    }
  );
};

const getShopTransferDetails = (data) => {
  return axios.get(
    API_URLU +
    "shop-trans-detailvw?cmpId=" +
    data.cmpId +
    "&sthId=" +
    data.sthId,
    {
      headers: authHeader(),
    }
  );
};

const getTransferInvoiceReport = (data) => {
  return axios.get(
    API_URLU +
    "transfer-invoice-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&cmpId=" +
    data.cmpId +
    "&phdId=" +
    data.phdId +
    "&approvedBy=" +
    data.approvedBy +
    "&vendor=" +
    data.vendor +
    "&poNumber=" +
    data.poNumber +
    "&poDate=" +
    data.poDate +
    "&shop=" +
    data.shop +
    "&Collected_by=" +
    data.Collected_by +
    "&Dispatcher=" +
    data.Dispatcher +
    "&url=" +
    data.url +
    "&oldOrderNumber=" +
    data.oldOrderNumber,
    {
      headers: authHeader(),
    }
  );
};

const getSupplierEmail = (data) => {
  return axios.get(
    API_URLU +
    "supplier-emails?supplierCode=" +
    data.supplierCode +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const sendLpoMail = (data) => {
  return axios.get(
    API_URLU +
    "send-lpo-email?email=" +
    data.email +
    "&repName=" +
    data.repName,
    {
      headers: authHeader(),
    }
  );
};

const saleItems = (data) => {
  return axios.get(
    API_URLU +
    "get-sale-items?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    {
      headers: authHeader(),
    }
  );
};

const saleItems2 = (data) => {
  return axios.get(
    API_URLU +
    "get-sale-items2?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    {
      headers: authHeader(),
    }
  );
};

const saleItems3 = (data) => {
  return axios.get(
    API_URLU +
    "get-sale-items3?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode +
    "&stockCode=" +
    data.stockCode,
    {
      headers: authHeader(),
    }
  );
};

const postSalesHeader = (data) => {
  return axios.post(API_URLU + "sale-header", data, { headers: authHeader() });
};

const postSalesDetails = (data) => {
  return axios.post(API_URLU + "sale-details", data, { headers: authHeader() });
};

const getSalesDetailsBySshId = (id) => {
  return axios.get(API_URLU + "sale-details-ssh?sshId=" + id, {
    headers: authHeader(),
  });
};

const postSalesParticular = (data) => {
  return axios.post(API_URLU + "sale-particulars", data, {
    headers: authHeader(),
  });
};

const getSalesParticularBySshId = (id) => {
  return axios.get(API_URLU + "sale-particulars-ssh?sshId=" + id, {
    headers: authHeader(),
  });
};

const getSalesHeader = (id, id2) => {
  return axios.get(
    API_URLU + "cmp-sale-header?cmpId=" + id + "&saleType=" + id2,
    { headers: authHeader() }
  );
};

const getHPSalesHeaderNew = (data) => {
  return axios.get(
    API_URLU +
    "hp-sales-cmpidNew/" +
    data.id +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    { headers: authHeader() }
  );
};

const getHPSalesHeaderSearchNew = (data) => {
  return axios.get(
    API_URLU +
    "hp-sales-searchNew/" +
    data.id +
    "/" +
    data.searchParam +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    {
      headers: authHeader(),
    }
  );
};

const getHPSalesHeader = (data) => {
  return axios.get(
    API_URLU +
    "hp-sales-cmpid/" +
    data.id +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    { headers: authHeader() }
  );
};

const getHPSalesHeaderSearch = (data) => {
  return axios.get(
    API_URLU +
    "hp-sales-search/" +
    data.id +
    "/" +
    data.searchParam +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    {
      headers: authHeader(),
    }
  );
};

const getHPPreSalesHeader = (id) => {
  return axios.get(API_URLU + "hp-prepost-sales?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getReceiptTranCodes = (cmpId) => {
  return axios.get(API_URLU + "receipt-codes/" + cmpId, {
    headers: authHeader(),
  });
};

const findPaymentModes = () => {
  return axios.get(API_URLU + "payment-modes", { headers: authHeader() });
};
const getCustomerCodes = (cmpId) => {
  return axios.get(API_URLU + "customer-codes/" + cmpId, {
    headers: authHeader(),
  });
};

const getPolicyInformation = (custCode) => {
  return axios.get(API_URLU + "policy-information/" + custCode, {
    headers: authHeader(),
  });
};

const getSaleInformation = (data) => {
  return axios.get(
    API_URLU +
    "sale-information/" +
    data.cmpId +
    "/" +
    data.branchCode +
    "/" +
    data.custCode +
    "/" +
    data.saleType,
    {
      headers: authHeader(),
    }
  );
};

const getAddress = (clientNumber) => {
  return axios.get(API_URLU + "client-address/" + clientNumber, {
    headers: authHeader(),
  });
};

const getAllBankAccounts = (cmpId) => {
  return axios.get(API_URLU + "company-accounts/" + cmpId, {
    headers: authHeader(),
  });
};

const getAllCreditAccounts = (cmpId) => {
  return axios.get(API_URLU + "credit-accounts/" + cmpId, {
    headers: authHeader(),
  });
};

const getLinkedCustomerAccounts = (cmpId, custCode) => {
  return axios.get(
    API_URLU + "linked-customer-accounts/" + cmpId + "/" + custCode,
    { headers: authHeader() }
  );
};

const getCustomerSubaccounts = (cmpId, custCode) => {
  return axios.get(
    API_URLU + "get-customer-subaccount/" + cmpId + "/" + custCode,
    { headers: authHeader() }
  );
};

const getDocDetails = (cmpId, tranCode, docDate, auto) => {
  return axios.get(
    API_URLU +
    "doc_number?cmpId=" +
    cmpId +
    "&trancode=" +
    tranCode +
    "&docdate=" +
    docDate +
    "&auto=" +
    auto,
    {
      headers: authHeader(),
    }
  );
};

const docAvailable = (data) => {
  return axios.get(
    API_URLU +
    "is-doc-number-available?accountYear=" +
    data.accountYear +
    "&tranCode=" +
    data.tranCode +
    "&docNumber=" +
    data.docNumber +
    "&cmpId=" +
    data.cmpId,
    { headers: authHeader() }
  );
};

const getCompanyBanks = (cmpId) => {
  return axios.get(API_URLU + "customer-banks/" + cmpId, {
    headers: authHeader(),
  });
};

const getReceiptHeaderApprovalStatus = (cmpId, rhdId) => {
  return axios.get(API_URLU + "is-header-approved/" + cmpId + "/" + rhdId, {
    headers: authHeader(),
  });
};

const approveReceiptHeader = (cmpId, rhdId, user) => {
  return axios.get(
    API_URLU + "approve-receipt-header/" + cmpId + "/" + rhdId + "/" + user,
    { headers: authHeader() }
  );
};

const poReports = (id) => {
  return axios.get(API_URLU + "po-reports?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getPoReportDetails = (data) => {
  return axios.get(
    API_URLU +
    "po-report-details?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&approvalStatus=" +
    data.approvalStatus,
    {
      headers: authHeader(),
    }
  );
};

const getPoReportDetailsRange = (data) => {
  return axios.get(
    API_URLU +
    "po-report-details-daterange?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&approvalStatus=" +
    data.approvalStatus +
    "&startDate=" +
    data.startDate +
    "&endDate=" +
    data.endDate,
    {
      headers: authHeader(),
    }
  );
};

const getPoReportDetailsByPhd = (data) => {
  return axios.get(
    API_URLU +
    "po-details-byphd?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&approvalStatus=" +
    data.approvalStatus +
    "&phdId=" +
    data.phdId,
    {
      headers: authHeader(),
    }
  );
};

const getPurchaseReport2 = (data) => {
  return axios.get(
    API_URLU +
    "purchase-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId,
    {
      headers: authHeader(),
    }
  );
};

const getSaleTypes = (id) => {
  return axios.get(API_URLU + "get-sale-type?cmpId=" + id, {
    headers: authHeader(),
  });
};

const companyReceipts = (cmpId) => {
  return axios.get(API_URLU + "get-company-receipts/" + cmpId, {
    headers: authHeader(),
  });
};

const getSelectedReceiptDetails = (id) => {
  return axios.get(API_URLU + "get-receipt-by-rhdid/" + id, {
    headers: authHeader(),
  });
};

const getPaymentHeaders = (data) => {
  return axios.get(API_URLU + "cfspaymentheaders-vw?cmpId=" + data.cmpId + '&startDate=' + data.startDate + '&endDate=' + data.endDate, {
    headers: authHeader(),
  });
};

const getPaymentDetails = () => {
  return axios.get(API_URLU + "payment-details", { headers: authHeader() });
};

const getPaymentHeaderByHeaderId = (phdId) => {
  return axios.get(API_URLU + "payment-headers/" + phdId, {
    headers: authHeader(),
  });
};

const getAllPaymentHeaders = () => {
  return axios.get(API_URLU + "payment-headers", { headers: authHeader() });
};

const postPaymentHeaders = (data) => {
  return axios.post(API_URLU + "payment-headers", data, {
    headers: authHeader(),
  });
};

const postGltranHeaders = (data) => {
  return axios.post(API_URLU + "gltran-headers", data, {
    headers: authHeader(),
  });
};

const postGltranDetails = (data) => {
  return axios.post(API_URLU + "gltran-details", data, {
    headers: authHeader(),
  });
};

const putPaymentHeaders = (phdId, data) => {
  return axios.put(API_URLU + "payment-headers/" + phdId, data, {
    headers: authHeader(),
  });
};

const postPaymentDetails = (data) => {
  return axios.post(API_URLU + "payment-details", data, {
    headers: authHeader(),
  });
};

const postPaymentParticulars = (data) => {
  return axios.post(API_URLU + "payment-particulars", data, {
    headers: authHeader(),
  });
};

const deletePaymentDetails = (data) => {
  return axios.delete(
    API_URLU + "payment-details?phdId=" + data.phdId + "&cmpId=" + data.cmpId,
    { headers: authHeader() }
  );
};

const getInvoiceHeaders = (data) => {
  return axios.get(API_URLU + "cfsinvoiceheaders-vw?cmpId=" + data.cmpId + '&startDate=' + data.startDate + '&endDate=' + data.endDate, {
    headers: authHeader(),
  });
};

const getPaymentDetailsByHeaderId = (data) => {
  return axios.get(
    API_URLU +
    "payment-details_vw?phdId=" +
    data.phdId +
    "&userId=" +
    data.userId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getPaymentParticularByHeaderId = (data) => {
  return axios.get(
    API_URLU +
    "payment-particular_vw?phdId=" +
    data.phdId +
    "&userId=" +
    data.userId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getInvoiceTransactionCodes = (cmpId) => {
  return axios.get(API_URLU + "cfsinvoice-codes?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getPaymentTransactionCodes = (cmpId) => {
  return axios.get(API_URLU + "cfspayment-codes?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getPaymentModes = () => {
  return axios.get(API_URLU + "cfspayment-modes", { headers: authHeader() });
};

const getOurRef = () => {
  return axios.get(API_URLU + "cfspayments-ourref", { headers: authHeader() });
};

const getMainAccounts = () => {
  return axios.get(API_URLU + "cfsmain-acc", { headers: authHeader() });
};

const getSubAccountsByMain = (data) => {
  return axios.get(
    API_URLU +
    "cfssub-acc?accountCode=" +
    data.accountCode +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getCustBank = (data) => {
  return axios.get(API_URLU + "cfs-custbanks?cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const getBranches = () => {
  return axios.get(API_URLU + "branch", { headers: authHeader() });
};

const getBranchesByCmpId = (cmpId) => {
  return axios.get(API_URLU + "branches-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getDepartments = () => {
  return axios.get(API_URLU + "get-departments", { headers: authHeader() });
};

const getPaymentReport = (data) => {
  return axios.get(
    API_URLU +
    "purchase-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&cmpId=" +
    data.cmpId +
    "&phdId=" +
    data.phdId,
    {
      headers: authHeader(),
    }
  );
};

const approvePaymentHeader = (data) => {
  return axios.get(
    API_URLU +
    "approve-payment-header?invoicePhdId=" +
    data.invoicePhdId +
    "&phdID=" +
    data.phdID +
    "&docDate=" +
    data.docDate +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user +
    "&tranCode=" +
    data.tranCode +
    "&lcAmount=" +
    data.lcAmount +
    "&action=" +
    data.action,
    { headers: authHeader() }
  );
};

const getPaymentDocNumber = (data) => {
  return axios.get(
    API_URLU +
    "get-payment-doc-number?cmpId=" +
    data.cmpId +
    "&tranCode=" +
    data.tranCode +
    "&docDate=" +
    data.docDate +
    "&accountYear=" +
    data.accountYear,
    { headers: authHeader() }
  );
};

const getInvoiceBalance = (data) => {
  return axios.get(API_URLU + "get-invoice-balance?phdId=" + data.phdId, {
    headers: authHeader(),
  });
};

const getTranTypes = (cmpId) => {
  return axios.get(API_URLU + "get-tran-types?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};
const getSaleFinTrans = (data) => {
  return axios.get(
    API_URLU +
    "cmp-sale-fin-trans?sshId=" +
    data.sshId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const genSaleFinTrans = (data) => {
  return axios.get(
    API_URLU +
    "gen-sale-fin-trans?sshId=" +
    data.sshId +
    "&cmpId=" +
    data.cmpId +
    "&saleDate=" +
    data.saleDate +
    "&username=" +
    data.username,

    {
      headers: authHeader(),
    }
  );
};

const postSaleFinGL = (data) => {
  return axios.get(
    API_URLU +
    "post-sale-fin-trans?sshId=" +
    data.sshId +
    "&username=" +
    data.username,

    {
      headers: authHeader(),
    }
  );
};

const linkCustomerAccount = (data) => {
  return axios.get(
    API_URLU +
    "link-debtor-subaccount?custCode=" +
    data.custCode +
    "&user=" +
    data.user +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const generateCustomerSubaccount = (data) => {
  return axios.get(
    API_URLU +
    "generate-customer-subaccout?cmpId=" +
    data.cmpId +
    "&custCode=" +
    data.custCode +
    "&user=" +
    data.user,
    {
      headers: authHeader(),
    }
  );
};

const getUnbankedReceipts = (cmpId, user) => {
  return axios.get(
    API_URLU + "get-unbanked-receipts?cmpId=" + cmpId + "&user=" + user,
    { headers: authHeader() }
  );
};

const getBankingTranCode = (cmpId) => {
  return axios.get(API_URLU + "get-banking-trancode/" + cmpId, {
    headers: authHeader(),
  });
};
const getBankingDocNumber = (data) => {
  return axios.get(
    API_URLU +
    "get-banking-doc-number?tranCode=" +
    data.tranCode +
    "&docDate=" +
    data.docDate +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const postReceiptBankHeader = (data) => {
  return axios.post(API_URLU + "bank-receipt-header", data, {
    headers: authHeader(),
  });
};

const putReceiptBankHeader = (id, data) => {
  return axios.put(API_URLU + "bank-receipt-header/" + id, data, {
    headers: authHeader(),
  });
};

const postReceiptBankDetails = (data) => {
  return axios.post(API_URLU + "receipt-banking-details", data, {
    headers: authHeader(),
  });
};

const postPoEmails = (data) => {
  return axios.post(API_URLU + "emailed-pos", data, { headers: authHeader() });
};

const getEmailedPoLPOs = (cmpId, phdID) => {
  return axios.get(API_URLU + "emailed-pos/" + cmpId + "/" + phdID, {
    headers: authHeader(),
  });
};

const getSupplierEmails = (cmpId, supplierCode) => {
  return axios.get(API_URLU + "supplier-emails/" + cmpId + "/" + supplierCode, {
    headers: authHeader(),
  });
};

const postSupplierEmails = (data) => {
  return axios.post(API_URLU + "supplier-emails", data, {
    headers: authHeader(),
  });
};
const putSupplierEmails = (seId, data) => {
  return axios.put(API_URLU + "supplier-emails/" + seId, data, {
    headers: authHeader(),
  });
};

const delSupplierEmails = (seId) => {
  return axios.delete(API_URLU + "supplier-emails/" + seId, {
    headers: authHeader(),
  });
};

const getCompanyBranches = (id) => {
  return axios.get(API_URLU + "company-branches/" + id, {
    headers: authHeader(),
  });
};
const putCompany = (cmpId, data) => {
  return axios.put(API_URLU + "company/" + cmpId, data, {
    headers: authHeader(),
  });
};
const getBranch = (id) => {
  return axios.get(API_URLU + "branch/" + id, { headers: authHeader() });
};

const putBranch = (id, data) => {
  return axios.put(API_URLU + "branch/" + id, data, { headers: authHeader() });
};
const postBranch = (data) => {
  return axios.post(API_URLU + "branch", data, { headers: authHeader() });
};

const postHpAccount = (data) => {
  return axios.post(API_URLU + "hp-accounts", data, { headers: authHeader() });
};

const postHpAccountGuarantor = (data) => {
  return axios.post(API_URLU + "hp-account-guarantors", data, {
    headers: authHeader(),
  });
};

const getHpAccountHist = (data) => {
  return axios.get(
    API_URLU +
    "hp-account-hist?custCode=" +
    data.custCode +
    "&hpId=" +
    data.hpId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getHpAccountGuarantorHist = (data) => {
  return axios.get(
    API_URLU +
    "hp-quarantor-hist?custCode=" +
    data.custCode +
    "&hpId=" +
    data.hpId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getHpAccByCustCode = (data) => {
  return axios.get(
    API_URLU +
    "hp-accounts-cust-code?cmpId=" +
    data.cmpId +
    "&custCode=" +
    data.custCode,
    {
      headers: authHeader(),
    }
  );
};

const getHpAccByCmpId = (id) => {
  return axios.get(API_URLU + "hp-accounts-cmpid?cmpId=" + id + "&activeYn=Y", {
    headers: authHeader(),
  });
};

const getHpAccByHpNo = (data) => {
  return axios.get(
    API_URLU +
    "hp-account-byHpno?custCode=" +
    data.custCode +
    "&hpNumber=" +
    data.hpNumber,
    {
      headers: authHeader(),
    }
  );
};

const getHpGuarantorsHistByHpNo = (data) => {
  return axios.get(
    API_URLU + "hp-account-guarantors-byHpno?hpNumber=" + data.hpNumber,
    {
      headers: authHeader(),
    }
  );
};

const getHpAllAttachments = () => {
  return axios.get(API_URLU + "hp-all-attachment", { headers: authHeader() });
};

const getHpAccGuarantors = (data) => {
  return axios.get(
    API_URLU +
    "hp-account-guarantors-byHpId?cmpId=" +
    data.cmpId +
    "&hpId=" +
    data.hpId,
    { headers: authHeader() }
  );
};

const getHpAccGuarantorsByCustCode = (cmpId) => {
  return axios.get(
    API_URLU + "hp-account-guarantors-bygcustCode?cmpId=" + cmpId,
    { headers: authHeader() }
  );
};

const genHPSchedule = (data) => {
  return axios.get(
    API_URLU +
    "gen-hp-schedule?cmpId=" +
    data.cmpId +
    "&instalAmount=" +
    data.instalAmount +
    "&agreementDate=" +
    data.agreementDate +
    "&instalMonths=" +
    data.instalMonths +
    "&username=" +
    data.username +
    "&hpId=" +
    data.hpId,
    { headers: authHeader() }
  );
};

const getHPSchedule = (id) => {
  return axios.get(API_URLU + "get-hp-schedule?hpId=" + id, {
    headers: authHeader(),
  });
};

const postHpDocs = (data) => {
  return axios.post(API_URLU + "post-hp-attachment", data, {
    headers: authHeader(),
  });
};

const getHpDocs = (id) => {
  return axios.get(API_URLU + "get-hp-attachment?hpId=" + id, {
    headers: authHeader(),
  });
};

const approveAndGenHpFin = (data) => {
  return axios.get(
    API_URLU +
    "approve-sale-header?cmpId=" +
    data.cmpId +
    "&sshId=" +
    data.sshId +
    "&hpId=" +
    data.hpId +
    "&hpNumber=" +
    data.hpNumber +
    "&username=" +
    data.username,
    { headers: authHeader() }
  );
};

const autoAllocReceipt = (data) => {
  return axios.get(
    API_URLU +
    "auto-alloc-receipt?saleId=" +
    data.saleId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    {
      headers: authHeader(),
    }
  );
};

const printReceipt = (id, data1) => {
  return axios.post(API_URLU + "receipt-report/" + id, data1, {
    headers: authHeader(),
  });
};

const printTemporaryReceipt = (data1) => {
  return axios.post(API_URLU + "receipt-temp-report", data1, {
    headers: authHeader(),
  });
};

const getAmountToWords = (amount) => {
  return axios.get(API_URLU + "amount-to-words/" + amount, {
    headers: authHeader(),
  });
};

const autoGenerateReceipt = (data) => {
  return axios.post(API_URLU + "auto-generate-receipt", data, {
    headers: authHeader(),
  });
};

const generateSuspenseReceipt = (data) => {
  return axios.post(API_URLU + "get-suspense-receipt", data, {
    headers: authHeader(),
  });
};

const getOriginalSaleReceipt = (saleId) => {
  return axios.get(API_URLU + "get-sale-receipt/" + saleId, {
    headers: authHeader(),
  });
};

const getSuspBal = (data) => {
  return axios.get(
    API_URLU +
    "susp-bal?custCode=" +
    data.custCode +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    {
      headers: authHeader(),
    }
  );
};

const postReceiptSaleInfo = (data) => {
  return axios.post(API_URLU + "receipt-sales-info", data, {
    headers: authHeader(),
  });
};

const getHpReceipts = (cmpId, dconNo) => {
  return axios.get(API_URLU + "hp-receipts/" + cmpId + "/" + dconNo, {
    headers: authHeader(),
  });
};

const printHpStatement = (id, cmpId, custCode, data1) => {
  return axios.post(
    API_URLU + "hp-statement-report/" + id + "/" + cmpId + "/" + custCode,
    data1,
    { headers: authHeader() }
  );
};

const getDefaultAccounts = (cmpId) => {
  return axios.get(API_URLU + "company-defaults/" + cmpId, {
    headers: authHeader(),
  });
};

const getActiveHPAccounts = (data) => {
  return axios.get(
    API_URLU +
    "hp-account-cust-nationalId?cmpId=" +
    data.cmpId +
    "&custCode=" +
    data.custCode,
    { headers: authHeader() }
  );
};

const getCompanyUserBranches = (cmpId) => {
  return axios.get(API_URLU + "get-company-user-branches/" + cmpId, {
    headers: authHeader(),
  });
};
const getUnApprovedHanded = (cmpId, handedTo) => {
  return axios.get(API_URLU + "handed-receipts/" + cmpId + "/" + handedTo, {
    headers: authHeader(),
  });
};

const postHandedReceipts = (data) => {
  return axios.post(API_URLU + "handed-receipts", data, {
    headers: authHeader(),
  });
};

const putHandedReceipts = (id, data) => {
  return axios.put(API_URLU + "handed-receipts/" + id, data, {
    headers: authHeader(),
  });
};

const fetchHandedReceiptDetails = (cmpId, hdoId) => {
  return axios.get(
    API_URLU + "handed-receipts-details/" + cmpId + "/" + hdoId,
    { headers: authHeader() }
  );
};

const postHandedReceiptDetails = (data) => {
  return axios.post(API_URLU + "handed-receipts-details", data, {
    headers: authHeader(),
  });
};

const putHandedReceiptDetails = (id, data) => {
  return axios.put(API_URLU + "handed-receipts-details/" + id, data, {
    headers: authHeader(),
  });
};

const saveHeaderHdoId = (rhdId, hdoId) => {
  return axios.get(
    API_URLU + "update-rct-header-hdoId/" + rhdId + "/" + hdoId,
    { headers: authHeader() }
  );
};

const handOverForBanking = (cmpId, user) => {
  return axios.get(API_URLU + "handover-for-banking/" + cmpId + "/" + user, {
    headers: authHeader(),
  });
};

const updateHandedDetails = (data) => {
  return axios.get(
    API_URLU +
    "update-handed-details?hddId=" +
    data.hddId +
    "&cmpId=" +
    data.cmpId +
    "&bankedBy=" +
    data.bankedBy +
    "&bankBatchId=" +
    data.bankBatchId,
    { headers: authHeader() }
  );
};

const getApprovedBatches = (cmpId, startDate, endDate) => {
  return axios.get(
    API_URLU +
    "approved-receipt-batches?cmpId=" +
    cmpId +
    "&startDate=" +
    startDate +
    "&endDate=" +
    endDate,
    {
      headers: authHeader(),
    }
  );
};

const getUnapprovedBatches = (cmpId, createdBy, bankedBy) => {
  return axios.get(
    API_URLU +
    "unverified-receipt-batches/" +
    createdBy +
    "/" +
    bankedBy +
    "/" +
    cmpId,
    { headers: authHeader() }
  );
};

const getVerifiedBatches = (cmpId) => {
  return axios.get(API_URLU + "verified-receipt-batches/" + cmpId, {
    headers: authHeader(),
  });
};

// const getApprovedBatches=(cmpId, user)=>{
//   return axios.get(API_URLU+'get-approved-banked-receipts/'+cmpId+'/'+user, {headers:authHeader()});
// }
const getBankedReceipts = (cmpId, rbhId) => {
  return axios.get(API_URLU + "banked-receipts/" + cmpId + "/" + rbhId, {
    headers: authHeader(),
  });
};
const postReceiptBanking = (data) => {
  return axios.get(
    API_URLU +
    "post-receipt-banking?rbhId=" +
    data.rbhId +
    "&docDate=" +
    data.docDate +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const poStocksForRejection = (cmpId, phdId) => {
  return axios.get(
    API_URLU + "get-po-stocks-for-rejection/" + cmpId + "/" + phdId,
    { headers: authHeader() }
  );
};

const transferStocksForRejection = (cmpId, sthId) => {
  return axios.get(
    API_URLU + "get-transfer-stocks-for-rejection/" + cmpId + "/" + sthId,
    { headers: authHeader() }
  );
};

const postRejectPos = (data) => {
  return axios.post(API_URLU + "rejected-pos", data, { headers: authHeader() });
};

const putRejectPos = (id, data) => {
  return axios.put(API_URLU + "rejected-pos/" + id, data, {
    headers: authHeader(),
  });
};

const getRejectedGaas = (cmpId, status, user) => {
  return axios.get(
    API_URLU + "get-rejected-gaas/" + cmpId + "/" + status + "/" + user,
    { headers: authHeader() }
  );
};

const updateRejectedGaas = (cmpId, rpoId, action, user) => {
  return axios.get(
    API_URLU +
    "update-rejected-gaas/" +
    cmpId +
    "/" +
    rpoId +
    "/" +
    action +
    "/" +
    user,
    { headers: authHeader() }
  );
};

const getRejectedPoGaas = (data) => {
  return axios.get(
    API_URLU +
    "get-rejected-po-gaas?cmpId=" +
    data.cmpId +
    "&phdId=" +
    data.phdId +
    "&purchaseType=" +
    data.purchaseType +
    "&status=" +
    data.status,
    { headers: authHeader() }
  );
};

const getStockDescription = (sshId, cmpId) => {
  return axios.get(API_URLU + "get-stock-description/" + sshId + "/" + cmpId, {
    headers: authHeader(),
  });
};

const getCLientIdNumber = (custCode) => {
  return axios.get(API_URLU + "get-client-id-Number/" + custCode, {
    headers: authHeader(),
  });
};

const getStockAdjustmentHeaders = (data) => {
  return axios.get(
    API_URLU +
    "stock-adjustment-headers?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode +
    "&status=" +
    data.status,
    { headers: authHeader() }
  );
};

const postStockAdjustmentHeaders = (data) => {
  return axios.post(API_URLU + "stock-adjustment-headers", data, {
    headers: authHeader(),
  });
};

const putStockAdjustmentHeaders = (id, data) => {
  return axios.put(API_URLU + "stock-adjustment-headers/" + id, data, {
    headers: authHeader(),
  });
};

const getStockAdjustmentDetails = (id) => {
  return axios.get(API_URLU + "stock-adjustment-details/" + id, {
    headers: authHeader(),
  });
};

const postStockAdjustmentDetails = (data) => {
  return axios.post(API_URLU + "stock-adjustment-details", data, {
    headers: authHeader(),
  });
};

const putStockAdjustmentDetails = (id, data) => {
  return axios.put(API_URLU + "stock-adjustment-details/" + id, data, {
    headers: authHeader(),
  });
};

const getCustomerSaleItems = (data) => {
  return axios.get(
    API_URLU +
    "customer-sale-items?custCode=" +
    data.custCode +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode +
    "&saleType=" +
    data.saleType,
    { headers: authHeader() }
  );
};

const insertAdjustmentDetails = (data) => {
  return axios.get(
    API_URLU +
    "insert-adjustment-details?sahId=" +
    data.sahId +
    "&tranCode=" +
    data.tranCode +
    "&stockCode=" +
    data.stockCode +
    "&cmpId=" +
    data.cmpId +
    "&sshId=" +
    data.sshId +
    "&custCode=" +
    data.custCode +
    "&description=" +
    data.description +
    "&branchCode=" +
    data.branchCode +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const getStockAdjustmentsByStatus = (data) => {
  return axios.get(
    API_URLU +
    "get-stock-adjustments-by-status?cmpId=" +
    data.cmpId +
    "&status=" +
    data.status +
    "&username=" +
    data.username,
    { headers: authHeader() }
  );
};

const genGlAdjustments = (data) => {
  return axios.get(
    "approve-adjustments?cmpId=" +
    data.cmpId +
    "&sahId=" +
    data.sahId +
    "&docDate=" +
    data.docDate +
    "&custName=" +
    data.custName +
    "&docType=" +
    data.docType +
    "&sshId=" +
    data.sshId,
    { headers: authHeader() }
  );
};

const getGlTransView = (cmpId) => {
  return axios.get(API_URLU + "cfvgl-trans-view/" + cmpId, {
    headers: authHeader(),
  });
};

const getGlTransViewId = (cmpId, gtdId) => {
  return axios.get(API_URLU + "cfvgl-trans-view-id/" + cmpId + "/" + gtdId, {
    headers: authHeader(),
  });
};

const getCustomerAttachments = (code) => {
  return axios.get(API_URLU + "customer_attachments?custCode=" + code, {
    headers: authHeader(),
  });
};

const postCustomerAttachments = (data) => {
  return axios.post(API_URLU + "customer_attachments", data, {
    headers: authHeader(),
  });
};

const getGeneralCodes = (cmpId, codeType) => {
  return axios.get(API_URLU + "cms-general-codes/" + cmpId + "/" + codeType, {
    headers: authHeader(),
  });
};

const postGeneralCodes = (data) => {
  return axios.post(API_URLU + "general-codes", data, {
    headers: authHeader(),
  });
};

const putGeneralCodes = (id, data) => {
  return axios.put(API_URLU + "cms-general-codes/" + id, data, {
    headers: authHeader(),
  });
};
const getAttachedMenuItems = (cmpId, sstId, mutId) => {
  return axios.get(
    API_URLU + "attached-menu-items/" + cmpId + "/" + sstId + "/" + mutId,
    { headers: authHeader() }
  );
};

const getAvailableCodes = (pLevel, cmpId, sstId, allId) => {
  return axios.get(
    API_URLU +
    "available-codes/" +
    pLevel +
    "/" +
    cmpId +
    "/" +
    sstId +
    "/" +
    allId,
    { headers: authHeader() }
  );
};

const postMainMenu = (data) => {
  return axios.post(API_URLU + "main-menus", data, { headers: authHeader() });
};
const getAttachedGoneItems = (cmpId, goneId) => {
  return axios.get(
    API_URLU + "get-attached-gone-items/" + cmpId + "/" + goneId,
    { headers: authHeader() }
  );
};

const getAvailableMenuAccessCodes = (cmpId, goneId, mutId) => {
  return axios.get(
    API_URLU + "get-menu-access-codes/" + cmpId + "/" + goneId + "/" + mutId,
    { headers: authHeader() }
  );
};

const postGoneMenu = (data) => {
  return axios.post(API_URLU + "gone-menus", data, { headers: authHeader() });
};

const getAttachedGtwoItems = (cmpId, gtwoId) => {
  return axios.get(
    API_URLU + "get-attached-gtwo-items/" + cmpId + "/" + gtwoId,
    { headers: authHeader() }
  );
};

const getAttachedGthreeItems = (cmpId, gthreeId) => {
  return axios.get(
    API_URLU + "get-attached-gthree-items/" + cmpId + "/" + gthreeId,
    { headers: authHeader() }
  );
};

const getAvailableGoneAccessCodes = (cmpId, goneId, gtwoId) => {
  return axios.get(
    API_URLU + "get-gone-access-codes/" + cmpId + "/" + goneId + "/" + gtwoId,
    { headers: authHeader() }
  );
};

const getAvailableGtwoAccessCodes = (cmpId, gtwoId, gthreeId) => {
  return axios.get(
    API_URLU + "get-gtwo-access-codes/" + cmpId + "/" + gtwoId + "/" + gthreeId,
    { headers: authHeader() }
  );
};

const postGtwoMenu = (data) => {
  return axios.post(API_URLU + "gtwo-menus", data, { headers: authHeader() });
};

const postGthreeMenu = (data) => {
  return axios.post(API_URLU + "gthree-menus", data, { headers: authHeader() });
};

const getAllMenuDeleteStatus = (pid, pcat) => {
  return axios.get(
    API_URLU + "get-all-menu-delete-status/" + pid + "/" + pcat,
    { headers: authHeader() }
  );
};

const deleteSystem = (id) => {
  return axios.delete(API_URLU + "system/" + id, { headers: authHeader() });
};

const deleteSystemMenus = (id) => {
  return axios.delete(API_URLU + "system-menus/" + id, {
    headers: authHeader(),
  });
};

const deleteGroupOneItems = (id) => {
  return axios.delete(API_URLU + "group-one-menus/" + id, {
    headers: authHeader(),
  });
};

const deleteGroupTwoItems = (id) => {
  return axios.delete(API_URLU + "group-two-menus/" + id, {
    headers: authHeader(),
  });
};

const deleteGroupThreeItems = (id) => {
  return axios.delete(API_URLU + "group-three-menus/" + id, {
    headers: authHeader(),
  });
};

const getAssignedRoleDeleteStatus = (pid, pcat) => {
  return axios.get(
    API_URLU + "get-assigned-role-revoke-status/" + pid + "/" + pcat,
    { headers: authHeader() }
  );
};

const deleteMainMenu = (id) => {
  return axios.delete(API_URLU + "main-menus/" + id, { headers: authHeader() });
};

const deleteGoneMenu = (id) => {
  return axios.delete(API_URLU + "gone-menus/" + id, { headers: authHeader() });
};

const deleteGtwoMenu = (id) => {
  return axios.delete(API_URLU + "gtwo-menus/" + id, { headers: authHeader() });
};

const deleteGthreeMenu = (id) => {
  return axios.delete(API_URLU + "gthree-menus/" + id, {
    headers: authHeader(),
  });
};

const approveAdjustments = (data) => {
  return axios.get(
    API_URLU +
    "approve-adjustment?cmpId=" +
    data.cmpId +
    "&sahId=" +
    data.sahId +
    "&docDate=" +
    data.docDate +
    "&custName=" +
    data.custName +
    "&docType=" +
    data.docType +
    "&sshId=" +
    data.sshId +
    "&user=" +
    data.user +
    "&statusComments=" +
    data.statusComments,
    { headers: authHeader() }
  );
};

const getAllocatedForBanking = (user, docDate) => {
  return axios.get(
    API_URLU + "allocated-for-banking?user=" + user + "&docDate=" + docDate,
    { headers: authHeader() }
  );
};

const getBankedFinTrans = (cmpId, branchCode, rbhId) => {
  return axios.get(
    API_URLU +
    "banked-fin-trans?cmpId=" +
    cmpId +
    "&branchCode=" +
    branchCode +
    "&rbhId=" +
    rbhId,
    {
      headers: authHeader(),
    }
  );
};

const getPendingTempReceipts = (data) => {
  return axios.get(
    API_URLU +
    "pending-temp-receipts?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    { headers: authHeader() }
  );
};

const getApprovedTempReceipts = (data) => {
  return axios.get(
    API_URLU +
    "approved-temp-receipts?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode +
    "&startDate=" +
    data.startDate +
    "&endDate=" +
    data.endDate,
    { headers: authHeader() }
  );
};

const getTempRctBalances = (data) => {
  return axios.get(
    API_URLU +
    "get-branch-temp-balances?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode +
    "&startDate=" +
    data.startDate +
    "&endDate=" +
    data.endDate,
    { headers: authHeader() }
  );
};

const getTemporaryReceiptBalances = (trhId, cmpId, branchCode) => {
  return axios.get(
    API_URLU + "get-temp-rct-bal/" + trhId + "/" + cmpId + "/" + branchCode,
    { headers: authHeader() }
  );
};

const getTempRctDetails = (data) => {
  return axios.get(
    API_URLU +
    "get-temp-receipt-details?trhId=" +
    data.trhId +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    {
      headers: authHeader(),
    }
  );
};
const postTempReceiptHeaders = (data) => {
  return axios.post(API_URLU + "temp-receipt-headers", data, {
    headers: authHeader(),
  });
};

const putTempReceiptHeaders = (id, data) => {
  return axios.put(API_URLU + "temp-receipt-headers/" + id, data, {
    headers: authHeader(),
  });
};

const postTempReceiptDetails = (data) => {
  return axios.post(API_URLU + "temp-receipt-details", data, {
    headers: authHeader(),
  });
};

const putTempReceiptDetails = (id, data) => {
  return axios.put(API_URLU + "temp-receipt-details/" + id, data, {
    headers: authHeader(),
  });
};

const deleteTempReceiptDetails = (id) => {
  return axios.delete(API_URLU + "temp-receipt-details/" + id, {
    headers: authHeader(),
  });
};

const getTemCustHPs = (data) => {
  return axios.get(
    API_URLU +
    "cust-temp-hps?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode +
    "&custCode=" +
    data.custCode,
    {
      headers: authHeader(),
    }
  );
};

const approveCancelTempReceipt = (data) => {
  return axios.get(
    API_URLU +
    "approve-cancel-temp-receipt?trhId=" +
    data.trhId +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode +
    "&action=" +
    data.action +
    "&user=" +
    data.user +
    "&comments=" +
    data.comments,
    { headers: authHeader() }
  );
};

const finalTempReceiptUtilization = (data) => {
  return axios.get(
    API_URLU +
    "utilize-temp-receipt?trhId=" +
    data.trhId +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    { headers: authHeader() }
  );
};

const getPendingUtilization = (cmpId, usrId) => {
  return axios.get(API_URLU + "pending-utilization/" + cmpId + "/" + usrId, {
    headers: authHeader(),
  });
};

const getApprovedUtilization = (data) => {
  return axios.get(
    API_URLU +
    "approved-utilization?cmpId=" +
    data.cmpId +
    "&userId=" +
    data.userId +
    "&startDate=" +
    data.startDate +
    "&endDate=" +
    data.endDate,
    { headers: authHeader() }
  );
};

const finalSuspenseReceiptUpdate = (data) => {
  return axios.get(
    API_URLU +
    "receipt-util-update?trhId=" +
    data.trhId +
    "&rhdId=" +
    data.rhdId +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    { headers: authHeader() }
  );
};
const getReceiptedTempReceipts = (data) => {
  return axios.get(
    API_URLU +
    "receipted-temp-receipts?cmpId=" +
    data.cmpId +
    "&usrId=" +
    data.usrId +
    "&firstDate=" +
    data.firstDate +
    "&lastDate=" +
    data.lastDate,
    { headers: authHeader() }
  );
};

const getTempReceipts = (data) => {
  return axios.get(
    API_URLU +
    "get-temp-receipt?trhId=" +
    data.trhId +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    {
      headers: authHeader(),
    }
  );
};

const getCustomerHist = (data) => {
  return axios.get(
    API_URLU +
    "customer-hist?cmpId=" +
    data.cmpId +
    "&custCode=" +
    data.custCode +
    "&oldNew=" +
    data.oldNew,
    {
      headers: authHeader(),
    }
  );
};

const postSafari = (data) => {
  return axios.post(API_URLU + "hp-safari-header", data, {
    headers: authHeader(),
  });
};

const updateSafari = (data) => {
  return axios.put(API_URLU + "hp-safari-header?hpsId=" + data.hpsId, data, {
    headers: authHeader(),
  });
};

const postSafariDetails = (data) => {
  return axios.post(API_URLU + "hp-safari-detail", data, {
    headers: authHeader(),
  });
};

const updateSafariDetails = (data) => {
  return axios.put(API_URLU + "hp-safari-detail?hpsdId=" + data.hpsdId, data, {
    headers: authHeader(),
  });
};

const getSafariByCmpId = (id) => {
  return axios.get(API_URLU + "hp-safari-header?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getSafariDetailsByHpsId = (id) => {
  return axios.get(API_URLU + "hp-safari-detail?hpsId=" + id, {
    headers: authHeader(),
  });
};

const postSafariSalesmen = (data) => {
  return axios.post(API_URLU + "hp-safari-salesmen", data, {
    headers: authHeader(),
  });
};

const getSafariSalesmenByHpsId = (id) => {
  return axios.get(API_URLU + "hp-safari-salesmen?hpsId=" + id, {
    headers: authHeader(),
  });
};

const getPeriodDaysByCmpId = (id) => {
  return axios.get(API_URLU + "cf-period-days?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getAmortHeaderByCmpId = (id) => {
  return axios.get(API_URLU + "hp-amort-header?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getAmortDetailsByAmhId = (id) => {
  return axios.get(API_URLU + "hp-amort-details?amhId=" + id, {
    headers: authHeader(),
  });
};

const genHpAmortization = (data) => {
  return axios.get(
    API_URLU +
    "gen-hp-amortization?cmpId=" +
    data.cmpId +
    "&period=" +
    data.period +
    "&username=" +
    data.username,
    {
      headers: authHeader(),
    }
  );
};

const approveHpAmortization = (data) => {
  return axios.get(
    API_URLU +
    "approve-hp-amortization?cmpId=" +
    data.cmpId +
    "&amhId=" +
    data.amhId +
    "&username=" +
    data.username,
    {
      headers: authHeader(),
    }
  );
};

const getCheckOffMonthsByCmpId = (id) => {
  return axios.get(API_URLU + "check-off-months?cmpId=" + id, {
    headers: authHeader(),
  });
};

const getJournalsByCmpId = (data) => {
  return axios.get(
    API_URLU +
    "journals-cmpid/" +
    data.id +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    { headers: authHeader() }
  );
};

const getJournalsByCmpIdAndId = (data) => {
  return axios.get(
    API_URLU +
    "journals-cmpid-id/" +
    data.id +
    "/" +
    data.tranCode +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    {
      headers: authHeader(),
    }
  );
};

const getJournalDetailsByHeaders = (jdtJhdId) => {
  return axios.get(API_URLU + "journal-details-header-id/" + jdtJhdId, {
    headers: authHeader(),
  });
};

const getJournalRepDetailsByHeaders = (jdtJhdId) => {
  return axios.get(API_URLU + "journal-repdetails-header-id/" + jdtJhdId, {
    headers: authHeader(),
  });
};

const postJournalHeaders = (data) => {
  return axios.post(API_URLU + "journal-headers", data, {
    headers: authHeader(),
  });
};

const postJournalDetails = (data) => {
  return axios.post(API_URLU + "journal-details", data, {
    headers: authHeader(),
  });
};

const putJournalHeaders = (jhdId, data) => {
  return axios.put(API_URLU + "journal-headers/" + jhdId, data, {
    headers: authHeader(),
  });
};

const putJournalDetails = (jdtId, data) => {
  return axios.put(API_URLU + "journal-details/" + jdtId, data, {
    headers: authHeader(),
  });
};

const getJournalHeadersById = (jhdId) => {
  return axios.get(API_URLU + "journal-headers-id/" + jhdId, {
    headers: authHeader(),
  });
};

const getJournalDetailsById = (jdtId) => {
  return axios.get(API_URLU + "journal-details-id/" + jdtId, {
    headers: authHeader(),
  });
};

const deleteJournalDetail = (jdtId) => {
  return axios.delete(API_URLU + "journal-details/" + jdtId, {
    headers: authHeader(),
  });
};

const approveJournalHeader = (data) => {
  return axios.get(
    API_URLU +
    "approve-journal-header?jhdId=" +
    data.jhdId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const getJournalVoucher = (data) => {
  return axios.get(
    API_URLU +
    "journal-voucher?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&jhdId=" +
    data.jhdId +
    "&narration=" +
    data.narration +
    "&status=" +
    data.status +
    "&description=" +
    data.description +
    "&totalCredits=" +
    data.totalCredits +
    "&totalDebits=" +
    data.totalDebits +
    "&docDate=" +
    data.docDate +
    "&createdDate=" +
    data.createdDate +
    "&approvedDate=" +
    data.approvedDate +
    "&createdBy=" +
    data.createdBy +
    "&approvedBy=" +
    data.approvedBy +
    "&docNumber=" +
    data.docNumber +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const reverseGlTransaction = (data) => {
  return axios.get(
    API_URLU +
    "reversegl-transaction?cmpId=" +
    data.cmpId +
    "&gthId=" +
    data.gthId +
    "&jhdId=" +
    data.jhdId +
    "&remarks=" +
    data.remarks +
    "&user=" +
    data.user +
    "&tranCode=" +
    data.tranCode +
    "&docNumber=" +
    data.docNumber +
    "&docDate=" +
    data.docDate,
    { headers: authHeader() }
  );
};

const getBankReconciliationBanks = () => {
  return axios.get(API_URLU + "bank-reconciliation-banks", {
    headers: authHeader(),
  });
};

const getBankStatementDetailsByHeaderId = (bshId) => {
  return axios.get(API_URLU + "bank-statement-details-header-id/" + bshId, {
    headers: authHeader(),
  });
};

const getBankStatementsHeadersByAccountCodeCmpId = (cmpId, accountCode) => {
  return axios.get(
    API_URLU +
    "all-bank-statement-headersaccountcode/" +
    cmpId +
    "/" +
    accountCode,
    { headers: authHeader() }
  );
};

const postBankRecHeaders = (data) => {
  return axios.post(API_URLU + "bank-statement-headers", data, {
    headers: authHeader(),
  });
};

const postBankRecDetails = (data) => {
  return axios.post(API_URLU + "bank-statement-details", data, {
    headers: authHeader(),
  });
};

const putBankRecHeaders = (bshId, data) => {
  return axios.put(API_URLU + "bank-statement-headers/" + bshId, data, {
    headers: authHeader(),
  });
};

const putBankRecDetails = (bsdId, data) => {
  return axios.put(API_URLU + "bank-statement-details/" + bsdId, data, {
    headers: authHeader(),
  });
};

const getBankRecHeadersById = (bshId) => {
  return axios.get(API_URLU + "cfs-bankstat-headers-id?bshId=" + bshId, {
    headers: authHeader(),
  });
};

const getBankRecDetailsById = (bsdId) => {
  return axios.get(API_URLU + "bank-statement-details-id/" + bsdId, {
    headers: authHeader(),
  });
};

const uploadBankStatementDetails = (formData) => {
  return axios.post(API_URLU + "upload-bank-statement-detailscsv", formData, {
    headers: authHeader(),
    "Content-Type": "multipart/form-data",
  });
};

const approveBankUpload = (data) => {
  return axios.get(
    API_URLU +
    "approve-bank-upload?bshId=" +
    data.bshId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    {
      headers: authHeader(),
    }
  );
};

const declineBankUpload = (data) => {
  return axios.get(
    API_URLU +
    "decline-bank-upload?bshId=" +
    data.bshId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    {
      headers: authHeader(),
    }
  );
};

const getAllglTransactions = (cmpId) => {
  return axios.get(API_URLU + "allgl-transactions/" + cmpId, {
    headers: authHeader(),
  });
};

const getStockReports = () => {
  return axios.get(API_URLU + "get-stock-reports", { headers: authHeader() });
};

const getAllBankOpenTransCmpId = (data) => {
  return axios.get(
    API_URLU +
    "all-bank-open-trans/" +
    data.id +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    { headers: authHeader() }
  );
};

const getAllBankOpenTransCmpIdandDocNumber = (data) => {
  return axios.get(
    API_URLU +
    "all-bank-open-trans-cmpid-docnumber/" +
    data.id +
    "/" +
    data.docNumber +
    "/" +
    data.offset +
    "/" +
    data.pageSize,
    {
      headers: authHeader(),
    }
  );
};

const getBankOpenTransByDetailId = (bsdId) => {
  return axios.get(API_URLU + "bank-open-trans-det-id?bsdId=" + bsdId, {
    headers: authHeader(),
  });
};

const getBankOpenTransByAccCodeFlag = (data) => {
  return axios.get(API_URLU + "bank-open-trans-det?accountCode=" + data.accountCode + '&debitCreditFlag=' + data.debitCreditFlag + '&cmpId=' + data.cmpId + '&startDate=' + data.startDate + '&endDate=' + data.endDate, {
    headers: authHeader(),
  });
};

const getMainAccountsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cfsmain-acccmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getBankRecTransactionCodes = (cmpId) => {
  return axios.get(API_URLU + "cfsbankrec-codes/" + cmpId, {
    headers: authHeader(),
  });
};

const getGlTransViewCmpId = (data) => {
  return axios.get(
    API_URLU +
    "cfvgl-trans-view-cmpid?cmpId=" + data.id,
    { headers: authHeader() }
  );
};

const getGlTransViewCmpIdandDocNumber = (data) => {
  return axios.get(
    API_URLU +
    "cfvgl-trans-view-cmpid-accountname/" +
    data.id +
    "/" +
    data.docNumber,
    {
      headers: authHeader(),
    }
  );
};

const getJournalTransactionCodes = (cmpId) => {
  return axios.get(API_URLU + "cfsjournals-codes/" + cmpId, {
    headers: authHeader(),
  });
};

const updateTranDetails = (data) => {
  return axios.get(
    API_URLU +
    "modify-trans-details?cmpId=" +
    data.cmpId +
    "&itemsystemserialno=" +
    data.itemsystemserialno +
    "&itemserialnumber=" +
    data.itemserialnumber +
    "&username=" +
    data.username +
    "&modifiedDate=" +
    data.modifiedDate,
    { headers: authHeader() }
  );
};

const hpBalance = (data) => {
  return axios.get(
    API_URLU +
    "hp-balance?cmpId=" +
    data.cmpId +
    "&sshId=" +
    data.sshId +
    "&subAccountCode=" +
    data.subAccountCode,
    {
      headers: authHeader(),
    }
  );
};

const getHpDiscounts = () => {
  return axios.get(API_URLU + "hp-discounts", { headers: authHeader() });
};

const getBranchTempBal = (cmpId, branchCode) => {
  return axios.get(
    API_URLU +
    "get-branch-temp-bal?cmpId=" +
    cmpId +
    "&branchCode=" +
    branchCode,
    { headers: authHeader() }
  );
};

const getHPDetails = (sshId) => {
  return axios.get(API_URLU + "hp-details/" + sshId, { headers: authHeader() });
};

const runStocksReport = (dts) => {
  return axios.get(
    API_URLU +
    "purchase-report?reportFormat=" +
    dts.reportFormat +
    "&repName=" +
    dts.repName +
    "&cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.periodfrom +
    "&endDate=" +
    dts.periodto,
    { headers: authHeader() }
  );
};

const getUnutilizedMpesa = (custCode) => {
  return axios.get(
    API_URLU + "get-unutilized-transactions?custCode=" + custCode,
    { headers: authHeader() }
  );
};

const getBranchUsers = (data) => {
  return axios.get(
    API_URLU +
    "branch-users?cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    { headers: authHeader() }
  );
};

const getPettyCashTrSusp = (cmpId, status, inOut) => {
  return axios.get(
    API_URLU +
    "company-branch-petty-cash?cmpId=" +
    cmpId +
    "&status=" +
    status +
    "&inOut=" +
    inOut,
    { headers: authHeader() }
  );
};

const postPettyCashTrSusp = (data) => {
  return axios.post(API_URLU + "company-branch-petty-cash", data, {
    headers: authHeader(),
  });
};

const putPettyCashTrSusp = (id, data) => {
  return axios.put(API_URLU + "company-branch-petty-cash/" + id, data, {
    headers: authHeader(),
  });
};

const getSafariDesc = (dts) => {
  return axios.get(
    API_URLU +
    "hp-safari-desc?custCode=" +
    dts.custCode +
    "&cmpId=" +
    dts.cmpId +
    "&sshId=" +
    dts.sshId +
    "&hpId=" +
    dts.hpId +
    "&hpDeposit=" +
    dts.hpDeposit,
    { headers: authHeader() }
  );
};

const updateSafariAdvanceReceived = (data) => {
  return axios.get(
    API_URLU +
    "update-advance-received?hsmId=" +
    data.hsmId +
    "&cmpId=" +
    data.cmpId +
    "&advanceReceivedComm=" +
    data.advanceReceivedComm,
    { headers: authHeader() }
  );
};

const updateFeedbackAccepted = (data) => {
  return axios.get(
    API_URLU +
    "update-feedback-accepted?hsmId=" +
    data.hsmId +
    "&cmpId=" +
    data.cmpId +
    "&username=" +
    data.username +
    "&feedback=" +
    data.feedback,
    { headers: authHeader() }
  );
};

const getHpSafariReport = (data) => {
  return axios.get(
    API_URLU +
    "hp-safari-report?cmpId=" +
    data.cmpId +
    "&hpNumber=" +
    data.hpNumber,
    { headers: authHeader() }
  );
};

const runHpSafariReport = (data) => {
  return axios.get(
    API_URLU +
    "purchase-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&cmpId=" +
    data.cmpId +
    "&hpNumber=" +
    data.hpNumber,
    {
      headers: authHeader(),
    }
  );
};

const updatePettyCash = (pooId, status, user, statusComments) => {
  return axios.get(
    API_URLU +
    "update-petty-cash?pooId=" +
    pooId +
    "&status=" +
    status +
    "&user=" +
    user +
    "&statusComments=" +
    statusComments,
    { headers: authHeader() }
  );
};

const finalPettyCashUpdate = (pooId, rhdId) => {
  return axios.get(
    API_URLU + "final-petty-cash-update?pooId=" + pooId + "&rhdId=" + rhdId,
    { headers: authHeader() }
  );
};

const getApprovedCancelledPettyCash = (data) => {
  return axios.get(
    API_URLU +
    "approved-cancelled-petty-cash?cmpId=" +
    data.cmpId +
    "&firstDate=" +
    data.firstDate +
    "&lastDate=" +
    data.lastDate,
    { headers: authHeader() }
  );
};

const getPendingExpenses = (cmpId, status) => {
  return axios.get(API_URLU + "petty-cash-expenses/" + cmpId + "/" + status, {
    headers: authHeader(),
  });
};

const getPendingBranchExpenses = (cmpId, inOut) => {
  return axios.get(
    API_URLU + "pending-expenses?cmpId=" + cmpId + "&inOut=" + inOut,
    { headers: authHeader() }
  );
};

const getPettyCashBal = (cmpId, branchCode) => {
  return axios.get(
    API_URLU +
    "get-petty-cash-balances?cmpId=" +
    cmpId +
    "&branchCode=" +
    branchCode,
    { headers: authHeader() }
  );
};

const postPettyCashExpenses = (data) => {
  return axios.post(API_URLU + "petty-cash-expenses", data, {
    headers: authHeader(),
  });
};

const putPettyCashExpenses = (id, data) => {
  return axios.put(API_URLU + "petty-cash-expenses/" + id, data, {
    headers: authHeader(),
  });
};

const getApprovedCancelledExpenses = (data) => {
  return axios.get(
    API_URLU +
    "approved-cancelled-expenses?cmpId=" +
    data.cmpId +
    "&firstDate=" +
    data.firstDate +
    "&lastDate=" +
    data.lastDate,
    { headers: authHeader() }
  );
};

const getPettyCashByExpId = (expId) => {
  return axios.get(API_URLU + "get-petty-cash-by-expId?expId=" + expId, {
    headers: authHeader(),
  });
};

const getRecoverableAmounts = (cmpId, branchCode) => {
  return axios.get(
    API_URLU +
    "get-recoverable-amounts?cmpId=" +
    cmpId +
    "&branchCode=" +
    branchCode,
    { headers: authHeader() }
  );
};

const getPendingCustTemps = (cmpId) => {
  return axios.get(API_URLU + "pending-cust-temps?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getApprovedCustTemps = (cmpId, firstDate, lastDate) => {
  return axios.get(
    API_URLU +
    "approved-cust-temps?cmpId=" +
    cmpId +
    "&firstDate=" +
    firstDate +
    "&lastDate=" +
    lastDate,
    { headers: authHeader() }
  );
};

const postCustTempOuts = (data) => {
  return axios.post(API_URLU + "cust-temp-outs", data, {
    headers: authHeader(),
  });
};

const putCustTempOuts = (id, data) => {
  return axios.put(API_URLU + "cust-temp-outs/" + id, data, {
    headers: authHeader(),
  });
};

const getPettyCashCustTemps = (tempId) => {
  return axios.get(API_URLU + "get-petty-cash-cust-temps?tempId=" + tempId, {
    headers: authHeader(),
  });
};

const getCustTempBal = (custCode, cmpId, branchCode) => {
  return axios.get(
    API_URLU +
    "get-cust-temp-bal?custCode=" +
    custCode +
    "&cmpId=" +
    cmpId +
    "&branchCode=" +
    branchCode,
    { headers: authHeader() }
  );
};

const getCfsMainAccounts = (cmpId) => {
  return axios.get(API_URLU + "cfs-main-accounts/" + cmpId, {
    headers: authHeader(),
  });
};

const getAllCfsMainAccounts = (cmpId) => {
  return axios.get(API_URLU + "cfs-all-main-accounts/" + cmpId, {
    headers: authHeader(),
  });
};

const getFrozenCfsMainAccounts = (cmpId) => {
  return axios.get(API_URLU + "cfs-frozen-main-accounts/" + cmpId, {
    headers: authHeader(),
  });
};

const getCfsMainAccountsById = (macId) => {
  return axios.get(API_URLU + "cfs-main-accounts-id/" + macId, {
    headers: authHeader(),
  });
};

const postCfsMainAccounts = (data) => {
  return axios.post(API_URLU + "cfs-main-accounts", data, {
    headers: authHeader(),
  });
};

const putCfsMainAccounts = (id, data) => {
  return axios.put(API_URLU + "cfs-main-accounts/" + id, data, {
    headers: authHeader(),
  });
};

const getCfsMainSubAccountsbyAccountCode = (accountCode, cmpId) => {
  return axios.get(
    API_URLU + "cfs-main-subaccounts-account/" + accountCode + "/ " + cmpId,
    { headers: authHeader() }
  );
};

const getCfsMainSubAccountsById = (msaId) => {
  return axios.get(API_URLU + "cfs-main-subaccounts-id/" + msaId, {
    headers: authHeader(),
  });
};

const postCfsMainSubAccounts = (data) => {
  return axios.post(API_URLU + "cfs-main-subaccounts", data, {
    headers: authHeader(),
  });
};

const putCfsMainSubAccounts = (id, data) => {
  return axios.put(API_URLU + "cfs-main-subaccounts/" + id, data, {
    headers: authHeader(),
  });
};

const getCfsAccountYearsByCmpid = (cmpId) => {
  return axios.get(API_URLU + "cfs-acc-years/" + cmpId, {
    headers: authHeader(),
  });
};

const getCfsAccountBudgetsByCmpidandYear = (cmpId, calenderYear) => {
  return axios.get(API_URLU + "cfs-acc-budgets/" + cmpId + "/" + calenderYear, {
    headers: authHeader(),
  });
};

const getCfsBranchBudgetsByCmpidandYear = (
  cmpId,
  calenderYear,
  calenderMonth
) => {
  return axios.get(
    API_URLU +
    "cfs-branch-budgets/" +
    cmpId +
    "/" +
    calenderYear +
    "/" +
    calenderMonth,
    { headers: authHeader() }
  );
};

const getCfsDeptBudgetsByCmpidYearandBranch = (
  cmpId,
  calenderYear,
  calenderMonth,
  branchCode
) => {
  return axios.get(
    API_URLU +
    "cfs-dept-budgets/" +
    cmpId +
    "/" +
    calenderYear +
    "/" +
    calenderMonth +
    "/" +
    branchCode,
    { headers: authHeader() }
  );
};

const getBankHeadersBySacco = (cmpId) => {
  return axios.get(API_URLU + "sac-bank-headers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getActiveBankHeadersBySacco = (cmpId) => {
  return axios.get(API_URLU + "sac-actbank-headers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postBankHeaders = (data) => {
  return axios.post(API_URLU + "sac-bank-headers", data, {
    headers: authHeader(),
  });
};

const putBankHeaders = (sysBankId, data) => {
  return axios.put(API_URLU + "sac-bank-headers/" + sysBankId, data, {
    headers: authHeader(),
  });
};

const getBankHeadersById = (sysBankId) => {
  return axios.get(API_URLU + "sac-bank-headers-id/" + sysBankId, {
    headers: authHeader(),
  });
};

const delBankHeaders = (sysBankId) => {
  return axios.delete(API_URLU + "sac-bank-headers/" + sysBankId, {
    headers: authHeader(),
  });
};

const getBankBranchesBySacco = (cmpId) => {
  return axios.get(API_URLU + "sac-bank-branches-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postBankBranches = (data) => {
  return axios.post(API_URLU + "sac-bank-branches", data, {
    headers: authHeader(),
  });
};

const putBankBranches = (sysBranchId, data) => {
  return axios.put(API_URLU + "sac-bank-branches/" + sysBranchId, data, {
    headers: authHeader(),
  });
};

const getBankBranchesById = (sysBranchId) => {
  return axios.get(API_URLU + "sac-bank-branches-id/" + sysBranchId, {
    headers: authHeader(),
  });
};

const getBankBranchesByHeader = (bankHeaderCode, cmpId) => {
  return axios.get(
    API_URLU +
    "sac-bank-branches-byheader-cmpid/" +
    bankHeaderCode +
    "/" +
    cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getActBankBranchesByHeader = (bankHeaderCode, cmpId) => {
  return axios.get(
    API_URLU +
    "sac-actbank-branches-byheader-cmpid/" +
    bankHeaderCode +
    "/" +
    cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getBankBranchesByCmpId = (cmpId) => {
  return axios.get(API_URLU + "sac-bank-branches-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const delBankBranches = (sysBranchId) => {
  return axios.delete(API_URLU + "sac-bank-branches/" + sysBranchId, {
    headers: authHeader(),
  });
};

const getMainSubAccountsBySubAccountCode = (subaccountCode, cmpId) => {
  return axios.get(
    API_URLU + "mainsub-subacc/" + subaccountCode + "/" + cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getSubAccountsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cfs-sub-accounts-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postMainSubAccounts = (data) => {
  return axios.post(API_URLU + "cfs-main-subaccounts", data, {
    headers: authHeader(),
  });
};

const postSubAccounts = (data) => {
  return axios.post(API_URLU + "cfs-sub-accounts", data, {
    headers: authHeader(),
  });
};

const putSubAccounts = (sacId, data) => {
  return axios.put(API_URLU + "cfs-sub-accounts/" + sacId, data, {
    headers: authHeader(),
  });
};

const getSubAccountsById = (sacId) => {
  return axios.get(API_URLU + "cfs-sub-accounts-id/" + sacId, {
    headers: authHeader(),
  });
};

const getInsurerCustomersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "insurance-customer-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCustomersToCreateSubAccount = (cmpId) => {
  return axios.get(API_URLU + "customers-create-subaccount/" + cmpId, {
    headers: authHeader(),
  });
};

const getAccountsToLinkBySubaccountCode = (cmpId, subaccountCode) => {
  return axios.get(
    API_URLU + "accounts-link-subaccountcode/" + cmpId + "/" + subaccountCode,
    {
      headers: authHeader(),
    }
  );
};

const getSubAccountsToLinkByAccountCode = (cmpId, accountCode) => {
  return axios.get(
    API_URLU + "subaccounts-link-account/" + cmpId + "/" + accountCode,
    {
      headers: authHeader(),
    }
  );
};

const getReceiptHeadersByCmpid = (cmpId) => {
  return axios.get(API_URLU + "receipt-headers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postReceiptHeader = (data) => {
  return axios.post(API_URLU + "receipt-headers", data, {
    headers: authHeader(),
  });
};

const putReceiptHeader = (id, data) => {
  return axios.put(API_URLU + "receipt-headers/" + id, data, {
    headers: authHeader(),
  });
};

const getReceiptHeader = (id) => {
  return axios.get(API_URLU + "receipt-headers-id/" + id, {
    headers: authHeader(),
  });
};

const postReceiptDetails = (data) => {
  return axios.post(API_URLU + "receipt-details", data, {
    headers: authHeader(),
  });
};

const putReceiptDetails = (id, data) => {
  return axios.put(API_URLU + "receipt-details/" + id, data, {
    headers: authHeader(),
  });
};

const getReceiptDetails = (id) => {
  return axios.get(API_URLU + "receipt-details-id/" + id, {
    headers: authHeader(),
  });
};

const deleteReceiptDetail = (id) => {
  return axios.delete(API_URLU + "receipt-details/" + id, {
    headers: authHeader(),
  });
};

const getReceiptDetailsByHeaderId = (rdtRhdId) => {
  return axios.get(API_URLU + "receipt-details-headerid/" + rdtRhdId, {
    headers: authHeader(),
  });
};

const findPaymentModesByCmpId = (cmpid) => {
  return axios.get(API_URLU + "payment-modes-cmpid/" + cmpid, {
    headers: authHeader(),
  });
};

const findReceiptTransactionCodes = (cmpid) => {
  return axios.get(API_URLU + "cfsreceipt-codes/" + cmpid, {
    headers: authHeader(),
  });
};

const getCashBankMainAccounts = (cmpid) => {
  return axios.get(API_URLU + "cash-bank-main-accounts/" + cmpid, {
    headers: authHeader(),
  });
};

const getAssetMainAccountsSubAccounts = (cmpid) => {
  return axios.get(API_URLU + "asset-main-sub-accounts/" + cmpid, {
    headers: authHeader(),
  });
};

const linkCmpMenus = (data) => {
  return axios.get(
    API_URLU + "link-cmp-menus?cmpId=" + data.cmpId + "&sstId=" + data.sstId,
    { headers: authHeader() }
  );
};

const getInvoicesWithBalanceForPayment = (cmpId) => {
  return axios.get(API_URLU + "invoice-with-balance?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postPaymentInvoices = (data) => {
  return axios.post(API_URLU + "payment-invoices", data, {
    headers: authHeader(),
  });
};

const getInvoicesPaidByPayment = (phdId) => {
  return axios.get(API_URLU + "inv-paidby-payment?phdId=" + phdId, {
    headers: authHeader(),
  });
};

const getJournalReport = (data) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&jhdId=" +
    data.jhdId +
    "&cmpId=" +
    data.cmpId,
    {
      headers: authHeader(),
    }
  );
};

const getPaymentVoucher = (data) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&phdId=" +
    data.phdId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    {
      headers: authHeader(),
    }
  );
};

const getReceipt = (data) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    data.reportFormat +
    "&repName=" +
    data.repName +
    "&rhdId=" +
    data.rhdId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    {
      headers: authHeader(),
    }
  );
};

const getAccountReports = () => {
  return axios.get(API_URLU + "get-cfs-reports", {
    headers: authHeader(),
  });
};

const runAccountsReport = (dts) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    dts.reportFormat +
    "&repName=" +
    dts.repName +
    "&cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode +
    "&firstAccount=" +
    dts.firstAccount +
    "&lastAccount=" +
    dts.lastAccount +
    "&accountCode=" +
    dts.accountCode +
    "&subaccountCode=" +
    dts.subaccountCode,
    { headers: authHeader() }
  );
};

const runBankrecReport = (dts) => {
  return axios.get(
    API_URLU +
    "accounts-report?reportFormat=" +
    dts.reportFormat +
    "&repName=" +
    dts.repName +
    "&accountCode=" +
    dts.accountCode +
    "&lastDate=" +
    dts.lastDate +
    "&bankName=" +
    dts.bankName +
    "&bankAccountNo=" +
    dts.bankAccountNo,
    { headers: authHeader() }
  );
};

const getTrialBalanceReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-trial-balance-report?cmpId=" +
    dts.cmpId +
    "&firstAccount=" +
    dts.firstAccount +
    "&lastAccount=" +
    dts.lastAccount +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate,
    { headers: authHeader() }
  );
};

const getGlActivityReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-gl-activity-report?startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode +
    "&cmpId=" +
    dts.cmpId +
    "&accountCode=" +
    dts.accountCode +
    "&subaccountCode=" +
    dts.subaccountCode,
    { headers: authHeader() }
  );
};

const getAllTranCodes = (cmpId) => {
  return axios.get(API_URLU + "transaction-codes?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const postTranCode = (data) => {
  return axios.post(API_URLU + "transaction-codes", data, {
    headers: authHeader(),
  });
};

const updateTranCode = (data) => {
  return axios.put(API_URLU + "transaction-codes/" + data.trcId, data, {
    headers: authHeader(),
  });
};

const getAllTranPrivs = (data) => {
  return axios.get(
    API_URLU +
    "transaction-privs?cmpId=" +
    data.cmpId +
    "&tranCode=" +
    data.tranCode,
    {
      headers: authHeader(),
    }
  );
};

const postTranPrivs = (data) => {
  return axios.post(API_URLU + "transaction-privs", data, {
    headers: authHeader(),
  });
};

const updateTranPrivs = (data) => {
  return axios.put(API_URLU + "transaction-privs/" + data.tprId, data, {
    headers: authHeader(),
  });
};

const getMainCategories = (cmpId) => {
  return axios.get(API_URLU + "asset-cat-header?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getCompanySystemUsers = (cmpId, sstId) => {
  return axios.get(API_URLU + "cmp-sst-user/" + cmpId + "/" + sstId, {
    headers: authHeader(),
  });
};

const getCfsCompanyBanks = (cmpId) => {
  return axios.get(API_URLU + "cfs-company-banks-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCategories = (code) => {
  return axios.get(API_URLU + "asset-cat-detail?assetCatCode=" + code, {
    headers: authHeader(),
  });
};

const postCfsCompanyBanks = (data) => {
  return axios.post(API_URLU + "cfs-company-banks", data, {
    headers: authHeader(),
  });
};

const getAssetDefinition = (code) => {
  return axios.get(API_URLU + "asset-definition?categoryCode=" + code, {
    headers: authHeader(),
  });
};

const getAssetDefinitionByCmpId = (code) => {
  return axios.get(API_URLU + "asset-definition-cmpid?cmpId=" + code, {
    headers: authHeader(),
  });
};

const updateCfsCompanyBanks = (data) => {
  return axios.put(API_URLU + "cfs-company-banks/" + data.cbnId, data, {
    headers: authHeader(),
  });
};

const postMainCategories = (data) => {
  return axios.post(API_URLU + "asset-cat-header", data, {
    headers: authHeader(),
  });
};

const getCfsCompanyBankChqDetails = (cbnId) => {
  return axios.get(API_URLU + "cfs-chq-details-cbnId/" + cbnId, {
    headers: authHeader(),
  });
};

const updatetMainCategories = (data) => {
  return axios.put(API_URLU + "asset-cat-header?actId=" + data.actId, data, {
    headers: authHeader(),
  });
};

const getCfsCompanyBankChqDetailsById = (bcdId) => {
  return axios.get(API_URLU + "cfs-chq-details/" + bcdId, {
    headers: authHeader(),
  });
};

const postCategories = (data) => {
  return axios.post(API_URLU + "asset-cat-detail", data, {
    headers: authHeader(),
  });
};

const getCurrency = (cmpId) => {
  return axios.get(API_URLU + "base-currency/" + cmpId, {
    headers: authHeader(),
  });
};

const updatetCategories = (data) => {
  return axios.put(API_URLU + "asset-cat-detail?ctgId=" + data.ctgId, data, {
    headers: authHeader(),
  });
};

const postCfsCompanyBankCheque = (data) => {
  return axios.post(API_URLU + "cfs-chq-details", data, {
    headers: authHeader(),
  });
};

const postItemDef = (data) => {
  return axios.post(API_URLU + "asset-definition", data, {
    headers: authHeader(),
  });
};

const updateCfsCompanyBankCheque = (data) => {
  return axios.put(API_URLU + "cfs-chq-details/" + data.bcdId, data, {
    headers: authHeader(),
  });
};

const updateItemDef = (data) => {
  return axios.put(API_URLU + "asset-definition?itmId=" + data.itmId, data, {
    headers: authHeader(),
  });
};

const getAccountsUserComp = (id) => {
  return axios.get(API_URLU + "accounts-user-companies?userId=" + id, {
    headers: authHeader(),
  });
};

const companySystemLink = (data) => {
  return axios.get(
    API_URLU +
    "company-system-link?cmpId=" +
    data.cmpId +
    "&sstId=" +
    data.sstId +
    "&email=" +
    data.email,
    { headers: authHeader() }
  );
};

const adminSystemLink = (data) => {
  return axios.get(
    API_URLU +
    "admin-system-link?cmpId=" +
    data.cmpId +
    "&sstId=" +
    data.sstId +
    "&usrId=" +
    data.usrId +
    "&email=" +
    data.email,
    { headers: authHeader() }
  );
};

const companyMenuLink = (data) => {
  return axios.get(
    API_URLU + "link-cmp-menus?cmpId=" + data.cmpId + "&sstId=" + data.sstId,
    { headers: authHeader() }
  );
};

const getJournalListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-journal-listing-report?cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode,
    { headers: authHeader() }
  );
};

const getPaymentListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-payment-listing-report?cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode,
    { headers: authHeader() }
  );
};

const getReceiptListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-receipt-listing-report?cmpId=" +
    dts.cmpId +
    "&startDate=" +
    dts.startDate +
    "&endDate=" +
    dts.endDate +
    "&branchCode=" +
    dts.branchCode,
    { headers: authHeader() }
  );
};

const updatebankBranchCode = (data) => {
  return axios.get(
    API_URLU + "update-branch-bank-code?sysBankId=" + data.sysBankId,
    { headers: authHeader() }
  );
};

const getTransactionPrivsByCmpIdAndTranCodeAndUserName = (dtls) => {
  return axios.get(
    API_URLU +
    "tran-privsby-user?cmpId=" +
    dtls.cmpId +
    "&tranCode=" +
    dtls.tranCode +
    "&userName=" +
    dtls.userName,
    { headers: authHeader() }
  );
};

const getControlAccountsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "account-control-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const postControlAccounts = (data) => {
  return axios.post(API_URLU + "account-control", data, {
    headers: authHeader(),
  });
};

const putControlAccounts = (actId, data) => {
  return axios.put(API_URLU + "account-control/" + actId, data, {
    headers: authHeader(),
  });
};

const getAccountPeriodsByCmpIdandCalendarYear = (cmpId, calendarYear) => {
  return axios.get(
    API_URLU + "account-periods-calendar-year/" + cmpId + "/" + calendarYear,
    { headers: authHeader() }
  );
};

const getAccountPeriodsByCmpIdandCalendarYearandCalendarMonth = (
  cmpId,
  calendarYear,
  calendarMonth
) => {
  return axios.get(
    API_URLU +
    "cfs-acc-budgets-month/" +
    cmpId +
    "/" +
    calendarYear +
    "/" +
    calendarMonth,
    { headers: authHeader() }
  );
};

const postPeriodYears = (data) => {
  return axios.post(API_URLU + "cfs-acc-years", data, {
    headers: authHeader(),
  });
};

const putPeriodYears = (ayrId, data) => {
  return axios.put(API_URLU + "cfs-acc-years/" + ayrId, data, {
    headers: authHeader(),
  });
};

const postPeriodMonths = (data) => {
  return axios.post(API_URLU + "account-periods", data, {
    headers: authHeader(),
  });
};

const putPeriodMonths = (aprId, data) => {
  return axios.put(API_URLU + "account-periods/" + aprId, data, {
    headers: authHeader(),
  });
};

const postAccountBudgets = (data) => {
  return axios.post(API_URLU + "cfs-acc-budgets", data, {
    headers: authHeader(),
  });
};

const putAccountBudgets = (acbId, data) => {
  return axios.put(API_URLU + "cfs-acc-budgets/" + acbId, data, {
    headers: authHeader(),
  });
};

const getAccountYearsById = (ayrId) => {
  return axios.get(API_URLU + "cfs-acc-years-id/" + ayrId, {
    headers: authHeader(),
  });
};

const getAccountPeriodMonthsById = (aprId) => {
  return axios.get(API_URLU + "account-periods-id/" + aprId, {
    headers: authHeader(),
  });
};

const getAccountBudgetsById = (acbId) => {
  return axios.get(API_URLU + "cfs-acc-budgets-id/" + acbId, {
    headers: authHeader(),
  });
};

const getAccBudgetsByCmpIdandYearandAccountCode = (data) => {
  return axios.get(
    API_URLU +
    "cfs-acc-budgets-acccode?cmpId=" +
    data.cmpId +
    "&calendarYear=" +
    data.calendarYear +
    "&accountCode=" +
    data.accountCode,
    { headers: authHeader() }
  );
};

const getAccBranchBudgetsByAccountYearandMonth = (data) => {
  return axios.get(
    API_URLU +
    "cfs-branch-budgets-acccode?cmpId=" +
    data.cmpId +
    "&calendarYear=" +
    data.calendarYear +
    "&calendarMonth=" +
    data.calendarMonth +
    "&accountCode=" +
    data.accountCode,
    { headers: authHeader() }
  );
};

const getAccDeptBudgetsByYearAndMonthAccountAndBranch = (data) => {
  return axios.get(
    API_URLU +
    "cfs-dept-budgets-acccode?cmpId=" +
    data.cmpId +
    "&calendarYear=" +
    data.calendarYear +
    "&calendarMonth=" +
    data.calendarMonth +
    "&accountCode=" +
    data.accountCode +
    "&branchCode=" +
    data.branchCode,
    { headers: authHeader() }
  );
};

const getItemParticular = (code) => {
  return axios.get(API_URLU + "asset-details?itemCode=" + code, {
    headers: authHeader(),
  });
};

const postItemParticular = (data) => {
  return axios.post(API_URLU + "asset-details", data, {
    headers: authHeader(),
  });
};

const updateItemParticular = (data) => {
  return axios.put(API_URLU + "asset-details?adtId=" + data.adtId, data, {
    headers: authHeader(),
  });
};

const getGeneralParamsCmpid = (cmpId) => {
  return axios.get(API_URLU + "general-params-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const postGeneralParams = (data) => {
  return axios.post(API_URLU + "general-params", data, {
    headers: authHeader(),
  });
};

const updateGeneralParams = (data) => {
  return axios.put(API_URLU + "general-params?gprId=" + data.gprId, data, {
    headers: authHeader(),
  });
};

const getGeneralParamsById = (gprId) => {
  return axios.get(API_URLU + "general-params-id/" + gprId, {
    headers: authHeader(),
  });
};

const getAccountRepheadersCmpid = (cmpId) => {
  return axios.get(API_URLU + "account-repheaders-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getAccountRepheadersParamcode = (paramCode, cmpId) => {
  return axios.get(API_URLU + "account-repheaders-paramcode/" + paramCode + "/" + cmpId, {
    headers: authHeader(),
  });
};

const postAccountRepHeaders = (data) => {
  return axios.post(API_URLU + "account-repheaders", data, {
    headers: authHeader(),
  });
};

const updateAccountRepHeaders = (data) => {
  return axios.put(API_URLU + "account-repheaders?marhId=" + data.marhId, data, {
    headers: authHeader(),
  });
};

const getAccountRepHeadersById = (marhId) => {
  return axios.get(API_URLU + "account-repheaders-id/" + marhId, {
    headers: authHeader(),
  });
};

const getAccountRepDetailsHeaderId = (repHeadersMarhId) => {
  return axios.get(API_URLU + "account-repdetails-headerid/" + repHeadersMarhId, {
    headers: authHeader(),
  });
};

const postAccountRepDetails = (data) => {
  return axios.post(API_URLU + "account-repdetails", data, {
    headers: authHeader(),
  });
};

const updateAccountRepDetails = (data) => {
  return axios.put(API_URLU + "account-repdetails?mardId=" + data.mardId, data, {
    headers: authHeader(),
  });
};

const getAccountRepDetailsById = (mardId) => {
  return axios.get(API_URLU + "account-repdetails-id/" + mardId, {
    headers: authHeader(),
  });
};

const getAccountRepAggregatesHeaderId = (repHeadersMarhId) => {
  return axios.get(API_URLU + "account-repaggregates-headerid/" + repHeadersMarhId, {
    headers: authHeader(),
  });
};

const postAccountRepAggregates = (data) => {
  return axios.post(API_URLU + "account-repaggregates", data, {
    headers: authHeader(),
  });
};

const updateAccountRepAggreagates = (data) => {
  return axios.put(API_URLU + "account-repaggregates?maraId=" + data.maraId, data, {
    headers: authHeader(),
  });
};

const getAccountRepAggregatesById = (maraId) => {
  return axios.get(API_URLU + "account-repaggregates-id/" + maraId, {
    headers: authHeader(),
  });
};

const getAccountReportsCmpid = (cmpId) => {
  return axios.get(API_URLU + "account-reports-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const postAccountReports = (data) => {
  return axios.post(API_URLU + "account-reports", data, {
    headers: authHeader(),
  });
};

const updateAccountReports = (data) => {
  return axios.put(API_URLU + "account-reports?repId=" + data.repId, data, {
    headers: authHeader(),
  });
};

const getAccountReportsById = (repId) => {
  return axios.get(API_URLU + "account-reports-id/" + repId, {
    headers: authHeader(),
  });
};

const getAccountRepAggreagatesByHeaderDetails = (data) => {
  return axios.get(API_URLU + "account-repaggregates-header-dets?reportFormatId=" + data.reportFormatId + "&sectionNo="
    + data.sectionNo + "&itemNo=" + data.itemNo + "&cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const getAccountRepDetailsByHeaderDetails = (data) => {
  return axios.get(API_URLU + "account-repdetails-header-dets?reportFormatId=" + data.reportFormatId + "&sectionNo="
    + data.sectionNo + "&itemNo=" + data.itemNo + "&cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const getCustTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'cust-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getClientTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'client-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getIdentificationTypeByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'identification-type-cmpid/' + cmpId, { headers: authHeader() });
};

const getOccupationCodesByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'occupation-codes-cmpid/' + cmpId, { headers: authHeader() });
};

const getOnluserInsurerCustomersByCmpId = (cmpId, usrId) => {
  return axios.get(API_URLU + 'onlusers-insurance-customer-cmpid/' + cmpId + '/' + usrId, { headers: authHeader() });
};

const getUsersPermittedForCustomers = (cmpId, custCode) => {
  return axios.get(API_URLU + 'users-permitted-cust/' + cmpId + '/' + custCode, { headers: authHeader() });
};

const getCompanyCustomerCode = (data) => {
  return axios.get(
    API_URLU +
    'get-company-custcode?cmpId=' +
    data.cmpId,
    { headers: authHeader() }
  );
};

const postOnlineCredential = (data) => {
  return axios.post(API_URLU + 'customer-credentials', data, { headers: authHeader() });
};

const getPermittedCustomerById = (copId) => {
  return axios.get(API_URLU + 'permitted-customers-id/' + copId, { headers: authHeader() });
};

const putOnlineCredential = (copId, data) => {
  return axios.put(API_URLU + 'customer-credentials/' + copId, data, { headers: authHeader() });
};

const postTranSerials = (data) => {
  return axios.post(API_URLU + "tran-serials", data, {
    headers: authHeader(),
  });
};

const postAccountGroups = (data) => {
  return axios.post(API_URLU + "account-groups", data, {
    headers: authHeader(),
  });
};

const updateAccountGroups = (data) => {
  return axios.put(API_URLU + "account-groups/" + data.grpId, data, {
    headers: authHeader(),
  });
};

const getAccountGroupsById = (grpId) => {
  return axios.get(API_URLU + "account-groups-id/" + grpId, {
    headers: authHeader(),
  });
};

const getAccountGroupsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "account-groups-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getMainAccountWithGroupsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cfsmain-acc-descr-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getFrozenMainAccountWithGroupsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cfsmain-acc-frozen-descr-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getMainAccountsReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-main-accounts-report?cmpId=" +
    dts.cmpId,
    { headers: authHeader() }
  );
};

const postDepartments = (data) => {
  return axios.post(API_URLU + "cms-departments", data, {
    headers: authHeader(),
  });
};

const updateDepartments = (data) => {
  return axios.put(API_URLU + "cms-departments/" + data.dprId, data, {
    headers: authHeader(),
  });
};

const getDepartmentsById = (dprId) => {
  return axios.get(API_URLU + "cms-departments-id/" + dprId, {
    headers: authHeader(),
  });
};

const getDepartmentsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cms-department-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postCostCenters = (data) => {
  return axios.post(API_URLU + "cost-centers", data, {
    headers: authHeader(),
  });
};

const updateCostCenters = (data) => {
  return axios.put(API_URLU + "cost-centers/" + data.cstId, data, {
    headers: authHeader(),
  });
};

const getCostCentersById = (cstId) => {
  return axios.get(API_URLU + "cost-centers-id/" + cstId, {
    headers: authHeader(),
  });
};

const getCostCentersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "cost-centers-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const generateCompanySerials = (data) => {
  return axios.get(
    API_URLU + "generate-cmp-serials?cmpId=" + data.cmpId + "&sstId=" + data.sstId,
    { headers: authHeader() }
  );
};

const getActiveCurrency = (cmpId) => {
  return axios.get(API_URLU + "active-company-currencies/" + cmpId, {
    headers: authHeader(),
  });
};

const getTranSerialsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "tran-serials-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getAllTranSerials = (data) => {
  return axios.get(
    API_URLU +
    "tran-serials-trancode?cmpId=" +
    data.cmpId +
    "&tranCode=" +
    data.tranCode,
    {
      headers: authHeader(),
    }
  );
};

const updateTranSerials = (data) => {
  return axios.put(API_URLU + "tran-serials/" + data.tsrId, data, {
    headers: authHeader(),
  });
};

const getCustClassificationByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'cust-classification-cmpid/' + cmpId, { headers: authHeader() });
};

const getDiscountCategoryByCmpId = (cmpId) => {
  return axios.get(API_URLU + 'discount-category-cmpid/' + cmpId, { headers: authHeader() });
};

const getAllCompanySuppliers = (cmpId) => {
  return axios.get(API_URLU + "company-suppliers?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const delinkSubAccount = (msaId) => {
  return axios.delete(API_URLU + "cfs-main-subaccounts/" + msaId, {
    headers: authHeader(),
  });
};

const deleteMainAccount = (macId) => {
  return axios.delete(API_URLU + "cfs-main-accounts/" + macId, {
    headers: authHeader(),
  });
};

const getMainSubAccountsReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-main-subaccounts-report?cmpId=" +
    dts.cmpId,
    { headers: authHeader() }
  );
};

const getAllCustomersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "insurance-customer-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getPendingSaleHeadersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "pendingcfs-sales-headers-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getProcessedSaleHeadersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "processedcfs-sales-headers-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const postSaleHeaders = (data) => {
  return axios.post(API_URLU + "cfs-sales-headers", data, {
    headers: authHeader(),
  });
};

const updateSaleHeaders = (data) => {
  return axios.put(API_URLU + "cfs-sales-headers/" + data.sshId, data, {
    headers: authHeader(),
  });
};

const getSaleHeadersById = (sshId) => {
  return axios.get(API_URLU + "cfs-sales-headers-id/" + sshId, {
    headers: authHeader(),
  });
};

const getSalesDetailsByHeaderId = (data) => {
  return axios.get(API_URLU + "cfs-sales-details-headerid/" + data.sshId, {
    headers: authHeader(),
  });
};

const postSaleDetails = (data) => {
  return axios.post(API_URLU + "cfs-sales-details", data, {
    headers: authHeader(),
  });
};

const updateSaleDetails = (data) => {
  return axios.put(API_URLU + "cfs-sales-details/" + data.ssdId, data, {
    headers: authHeader(),
  });
};

const getSaleDetailsById = (ssdId) => {
  return axios.get(API_URLU + "cfs-sales-details-id/" + ssdId, {
    headers: authHeader(),
  });
};

const getAssetsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "asset-details-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getAssetUnitsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "asset-units-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCustomerSalesForReceiptsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "receiptcfs-customer-sales-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getWalkinSalesForReceiptsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "receiptcfs-walkin-sales-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

// const getInvoiceReport = (data) => {
//   return axios.get(
//     API_URLU +
//     "accounts-report?reportFormat=" +
//     data.reportFormat +
//     "&repName=" +
//     data.repName +
//     "&phdId=" +
//     data.phdId +
//     "&cmpId=" +
//     data.cmpId +
//     "&user=" +
//     data.user +
//     "&sshId=" +
//     data.sshId,
//     {
//       headers: authHeader(),
//     }
//   );
// };

const findSaleTransactionCodes = (cmpid) => {
  return axios.get(API_URLU + "cfssale-codes/" + cmpid, {
    headers: authHeader(),
  });
};

const findCreditNoteTransactionCodes = (cmpid) => {
  return axios.get(API_URLU + "creditnote-codes/" + cmpid, {
    headers: authHeader(),
  });
};

const getSalesFinTransByHeaderId = (data) => {
  return axios.get(API_URLU + "cfs-salefin-trans-headerid/" + data.sshId, {
    headers: authHeader(),
  });
};

const getSalesFinTransBySshId = (data) => {
  return axios.get(API_URLU + "cfs-salefin-trans-sshId/" + data.sshId, {
    headers: authHeader(),
  });
};

const postSaleFinTrans = (data) => {
  return axios.post(API_URLU + "cfs-salefin-trans", data, {
    headers: authHeader(),
  });
};

const updateSaleFinTrans = (data) => {
  return axios.put(API_URLU + "cfs-salefin-trans/" + data.sftId, data, {
    headers: authHeader(),
  });
};

const getSaleFinTransById = (sftId) => {
  return axios.get(API_URLU + "cfs-salefin-trans-id/" + sftId, {
    headers: authHeader(),
  });
};

const postCfsSaleFinTrans = (data) => {
  return axios.get(
    API_URLU +
    "approve-cfs-stock-sale?sshId=" +
    data.sshId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const getDeclinedSaleHeadersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "declinedcfs-sales-headers-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getReceiptGlTransactionDetailsByHeaderId = (rhdId) => {
  return axios.get(API_URLU + "gl-receipt-tran-dets/" + rhdId, {
    headers: authHeader(),
  });
};

const getPaymentGlTransactionDetailsByHeaderId = (phdId) => {
  return axios.get(API_URLU + "gl-payment-tran-dets/" + phdId, {
    headers: authHeader(),
  });
};

const getJournalGlTransactionDetailsByHeaderId = (jhdId) => {
  return axios.get(API_URLU + "gl-journal-tran-dets/" + jhdId, {
    headers: authHeader(),
  });
};

const getCompanyClassifiedCustomerCode = (data) => {
  return axios.get(
    API_URLU +
    'get-company-classified-custcode?cmpId=' +
    data.cmpId + '&serialCode=' + data.serialCode,
    { headers: authHeader() }
  );
};

const postAssetUnit = (data) => {
  return axios.post(API_URLU + "asset-units", data, {
    headers: authHeader(),
  });
};

const updateAssetUnit = (data) => {
  return axios.put(API_URLU + "asset-units/" + data.untId, data, {
    headers: authHeader(),
  });
};

const getSalesReportsBySshId = (data) => {
  return axios.get(API_URLU + "get-sales-reports/" + data.sshId + "/" + data.cmpId, {
    headers: authHeader(),
  });
};

const getInvoiceReport = (data) => {
  return axios.get(
    API_URLU +
    "accounts-report", {
    params: data,
    headers: authHeader(),
  });
};

const findOtherTransactionCodes = (cmpid) => {
  return axios.get(API_URLU + "cfsother-codes/" + cmpid, {
    headers: authHeader(),
  });
};

const fetchAllUnbankedReceipts = (data) => {
  return axios.get(
    API_URLU +
    "all-unbanked-receipts", {
    params: data,
    headers: authHeader(),
  });
};

const fetchFilteredUnbankedReceipts = (data) => {
  return axios.get(
    API_URLU +
    "filtered-unbanked-receipts", {
    params: data,
    headers: authHeader(),
  });
};

const fetchPendingReceiptBankingHeaders = (cmpId) => {
  return axios.get(API_URLU + "pending-banking-headers/" + cmpId, {
    headers: authHeader(),
  });
};

const fetchApprovedReceiptBankingHeaders = (cmpId) => {
  return axios.get(API_URLU + "approved-banking-headers/" + cmpId, {
    headers: authHeader(),
  });
};

const fetchDeclinedReceiptBankingHeaders = (cmpId) => {
  return axios.get(API_URLU + "declined-banking-headers/" + cmpId, {
    headers: authHeader(),
  });
};

const fetchAllReceiptBankingHeaders = (cmpId) => {
  return axios.get(API_URLU + "all-banking-headers/" + cmpId, {
    headers: authHeader(),
  });
};

const fetchBankingDetailsByHeaders = (rbdId) => {
  return axios.get(API_URLU + "approved-batch-details/" + rbdId, {
    headers: authHeader(),
  });
};

const putReceiptBankDetails = (id, data) => {
  return axios.put(API_URLU + "receipt-banking-details/" + id, data, {
    headers: authHeader(),
  });
};

const getPaymentsonSelectedInvoice = (cmpId, invoicePhdId) => {
  return axios.get(API_URLU + "payments-selected-invoice/" + cmpId + "/" + invoicePhdId, {
    headers: authHeader(),
  });
};

const getGeneralCodeByCmpId = (cmpId) => {
  return axios.get(API_URLU + "general-codes-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getBankedReceiptDetailsByHeaderId = (rbhId, cmpId) => {
  return axios.get(API_URLU + "banking-receipt-details-header/" + rbhId + "/" + cmpId, {
    headers: authHeader(),
  });
};

const approveReceiptBanking = (data) => {
  return axios.get(
    API_URLU +
    "approve-receipt-banking?rbhId=" +
    data.rbhId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const getReceiptBankingGlTransactionDetailsByHeaderId = (rbhId) => {
  return axios.get(API_URLU + "gl-receipt-bank-dets/" + rbhId, {
    headers: authHeader(),
  });
};

const postAssetTranHeaders = (data) => {
  return axios.post(API_URLU + "asset-tran-headers", data, {
    headers: authHeader(),
  });
};

const updateAssetTranHeaders = (data) => {
  return axios.put(API_URLU + "asset-tran-headers/" + data.athId, data, {
    headers: authHeader(),
  });
};

const deleteAssetTranHeaders = (data) => {
  return axios.delete(API_URLU + "asset-tran-headers/" + data.athId, {
    headers: authHeader(),
  });
};

const postAssetTranDetails = (data) => {
  return axios.post(API_URLU + "asset-tran-details", data, {
    headers: authHeader(),
  });
};

const updateAssetTranDetails = (data) => {
  return axios.put(API_URLU + "asset-tran-details/" + data.atdId, data, {
    headers: authHeader(),
  });
};

const deleteAssetTranDetails = (data) => {
  return axios.delete(API_URLU + "asset-tran-details/" + data.atdId, {
    headers: authHeader(),
  });
};

const getEndYearJournalsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "endyear-journal-headers/" + cmpId, {
    headers: authHeader(),
  });
};

const generateEndYearJournalBrief = (data) => {
  return axios.get(
    API_URLU +
    "generate-yearend-journals?endDate=" +
    data.endDate +
    "&user=" +
    data.user +
    "&cmpId=" +
    data.cmpId +
    "&branchCode=" +
    data.branchCode,
    { headers: authHeader() }
  );
};

const clearOrPurgeEndYearJournalBrief = (data) => {
  return axios.get(
    API_URLU +
    "clear-purge-yearend-journals?accountYear=" +
    data.accountYear +
    "&cmpId=" +
    data.cmpId +
    "&tranCode=" +
    data.tranCode +
    "&action=" +
    data.action,
    { headers: authHeader() }
  );
};

const declineCfsSaleHeader = (data) => {
  return axios.get(
    API_URLU +
    "decline-cfs-saleheader?sshId=" +
    data.sshId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const getActiveAssetUnitsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "active-asset-units-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getStatementOfAccountsReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-account-statement-report?cmpId=" +
    dts.cmpId +
    "&subaccountCode=" +
    dts.subaccountCode +
    "&startDate=" +
    dts.startDate,
    { headers: authHeader() }
  );
};

const getDebtorsAgedListingReport = (dts) => {
  return axios.get(
    API_URLU +
    "get-debtors-ageing-report?cmpId=" +
    dts.cmpId +
    "&accountCode=" +
    dts.accountCode +
    "&endDate=" +
    dts.endDate,
    { headers: authHeader() }
  );
};

const getStockPriceListByStockCode = (stockCode, cmpId) => {
  return axios.get(API_URLU + "ist-stock-prices-stockcode/" + stockCode + "/" + cmpId, {
    headers: authHeader(),
  });
};

const postIstStockPrices = (data) => {
  return axios.post(API_URLU + "ist-stock-prices", data, {
    headers: authHeader(),
  });
};

const updateIstStockPrices = (data) => {
  return axios.put(API_URLU + "ist-stock-prices/" + data.prlId, data, {
    headers: authHeader(),
  });
};

const getStockPriceListByCmpid = (cmpId) => {
  return axios.get(API_URLU + "ist-stock-prices-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const duplicateIstStockPrices = (data) => {
  return axios.get(
    API_URLU +
    "duplicate-ist-stock-prices?cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const getStocksForSaleByCmpId = (data) => {
  return axios.get(API_URLU + "stocks-for-sale-cmpid?cmpId=" + data.cmpId + '&categoryCode=' + data.categoryCode, {
    headers: authHeader(),
  });
};

const getCfsReportcategories = (cmpId) => {
  return axios.get(API_URLU + "cfs-report-categories-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCfsReportsByCatId = (catId) => {
  return axios.get(API_URLU + "cfs-reports-catid/" + catId, {
    headers: authHeader(),
  });
};

const getPendingStockReqHeadersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "pend-stock-reqheaders-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getApprovedStockReqHeadersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "approved-stock-reqheaders-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getDeclinedStockReqHeadersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "declined-stock-reqheaders-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const postReqHeaders = (data) => {
  return axios.post(API_URLU + "ist-stock-reqheaders", data, {
    headers: authHeader(),
  });
};

const postReqDetails = (data) => {
  return axios.post(API_URLU + "ist-stock-reqdetails", data, {
    headers: authHeader(),
  });
};

const getReqHeadersById = (srhId) => {
  return axios.get(API_URLU + "ist-stock-reqheaders-id/" + srhId, {
    headers: authHeader(),
  });
};

const getReqDetailsByHeaderId = (data) => {
  return axios.get(API_URLU + "ist-stock-reqdetails-srhid/" + data.srhId, {
    headers: authHeader(),
  });
};

const updateReqHeaders = (data) => {
  return axios.put(API_URLU + "ist-stock-reqheaders/" + data.srhId, data, {
    headers: authHeader(),
  });
};

const updateReqDetails = (data) => {
  return axios.put(API_URLU + "ist-stock-reqdetails/" + data.srdId, data, {
    headers: authHeader(),
  });
};

const getItemsForRequisitionByCmpId = (cmpId) => {
  return axios.get(API_URLU + "items-for-requisition-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getIssuedStockReqHeadersByCmpId = (cmpId) => {
  return axios.get(API_URLU + "issued-stock-reqheaders-cmpid/" + cmpId, {
    headers: authHeader(),
  });
};

const getCategoriesCmpid = (code, cmpId) => {
  return axios.get(API_URLU + "asset-cat-detail-cmpid?assetCatCode=" + code + '&cmpId=' + cmpId, {
    headers: authHeader(),
  });
};

const getAssetDefinitionByCategory = (code, cmpId) => {
  return axios.get(API_URLU + "asset-definition-catcode?categoryCode=" + code + '&cmpId=' + cmpId, {
    headers: authHeader(),
  });
};

const getBatchesByLotId = (cmpId, lotId) => {
  return axios.get(API_URLU + "pod-batches-lotid?cmpId=" + cmpId + '&lotId=' + lotId, {
    headers: authHeader(),
  });
};

const getInternalTransactionCodes = (cmpId) => {
  return axios.get(API_URLU + "cfsinternal-codes/" + cmpId, {
    headers: authHeader(),
  });
};

const postIstStockReqFinTrans = (data) => {
  return axios.get(
    API_URLU +
    "approve-ist-stock-request?srhId=" +
    data.srhId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const getCurrentActivePriceByStockCode = (stockCode, cmpId) => {
  return axios.get(API_URLU + "ist-currstock-price-stockcode/" + stockCode + '/' + cmpId, {
    headers: authHeader(),
  });
};

const tenantPost = (data) => {
  return axios.post(API_URLU + "create?tenantId=" + data.cmpId + '&userId=' + data.usrId + '&username=' + data.username, {
    headers: authHeader(),
  });
};

const setTenants = (id) => {
  return axios.get(API_URLU + "set-tenants?tenantId=" + id, {
    headers: authHeader(),
  });
};

const getTenants = (id) => {
  return axios.get(API_URLU + "get-tenant?tenantId=" + id, {
    headers: authHeader(),
  });
};

const findBankStatUploadCodes = (cmpid) => {
  return axios.get(API_URLU + "bankstat-uploadcodes/" + cmpid, {
    headers: authHeader(),
  });
};

const postBankStatHeaders = (data) => {
  return axios.post(API_URLU + "cfs-bankstat-headers", data, {
    headers: authHeader(),
  });
};

const postBankStatDetails = (data) => {
  return axios.post(API_URLU + "cfs-bankstat-details", data, {
    headers: authHeader(),
  });
};

const putBankStatHeaders = (bshId, data) => {
  return axios.put(API_URLU + "cfs-bankstat-headers/" + bshId, data, {
    headers: authHeader(),
  });
};

const putBankStatDetails = (bsdId, data) => {
  return axios.put(API_URLU + "cfs-bankstat-details/" + bsdId, data, {
    headers: authHeader(),
  });
};

const getBankStatHeadersByCmpId = (data) => {
  return axios.get(API_URLU + "cfs-bankstat-headers?cmpId=" + data.cmpId + '&accountCode=' + data.accountCode, {
    headers: authHeader(),
  });
};

const getBankStatDetailsByHeaderId = (bshId) => {
  return axios.get(API_URLU + "cfs-bankstat-details?bshId=" + bshId, {headers: authHeader() });
};

const uploadBankStatDetails = (formData) => {
  return axios.post(API_URLU + "upload-bankstat-details-csv", formData, {
    headers: authHeader(),
    "Content-Type": "multipart/form-data",
  });
};

const getApproveBankRec = (data) => {
  return axios.get(API_URLU + "approve-bank-rec?bshId=" + data.bshId + '&cmpId=' + data.cmpId + '&username=' + data.username + '&tranCode=' + data.tranCode + '&openingBal=' + data.openingBal, {
    headers: authHeader(),
  });
};

const getApprovalRights = (data) => {
  return axios.get(API_URLU + "approval-bank-rec-right?cmpId=" + data.cmpId + '&username=' + data.username + '&tranCode=' + data.tranCode + '&openingBal=' + data.openingBal, {
    headers: authHeader(),
  });
};

const getBankDbAutomatch = (data) => {
  return axios.get(API_URLU + "bank-rec-automatch?bshId=" + data.bshId + '&cmpId=' + data.cmpId + '&username=' + data.username, {
    headers: authHeader(),
  });
};

const saveCsvData = (data) => {
  return axios.post(API_URLU + "save-csv-data", data, { headers: authHeader(), });
};

const clearUploadDetails = (bshId) => {
  return axios.get(API_URLU + "clearUploads?bshId=" + bshId, {
    headers: authHeader(),
  });
};

const getBankTtlAlloc = (d, d2) => {
  return axios.get(API_URLU + "bank-ttl-alloc?otrId=" + d + '&cmpId=' + d2, {
    headers: authHeader(),
  });
};

const postSingleMatch = (data) => {
  return axios.get(API_URLU + "bank-rec-singlematch?cbOtrId=" + data.cbOtrId + '&bsOtrId=' + data.bsOtrId + '&amount=' + data.amount + '&username=' + data.username + '&cmpId=' + data.cmpId, {
    headers: authHeader(),
  });
};

const getServiceForSaleByCmpId = (data) => {
  return axios.get(API_URLU + "services-for-sale-cmpid?cmpId=" + data.cmpId + '&categoryCode=' + data.categoryCode, {
    headers: authHeader(),
  });
};

const getAllCategories = (cmpId) => {
  return axios.get(API_URLU + "category-details?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getLinkedCustomers = (cmpId) => {
  return axios.get(API_URLU + "linked-customers?cmpId=" + cmpId, {
    headers: authHeader(),
  });
};

const getAssetServices = (data) => {
  return axios.get(API_URLU + "asset-services?cmpId=" + data.cmpId + '&categoryCode=' + data.categoryCode, {
    headers: authHeader(),
  });
};

const postAssetServices = (data) => {
  return axios.post(API_URLU + "asset-services", data, {
    headers: authHeader(),
  });
};

const updateAssetServices = (data) => {
  return axios.put(API_URLU + "asset-services?srvId=" + data.srvId, data, {
    headers: authHeader(),
  });
};

const getStatementReport = (data) => {
  return axios.post(
    API_URLU + "statement-report?cmpId=" + data.cmpId + '&sshId=' + data.sshId + '&repName=' + data.repname + 
    '&reportFormat=' + data.format + '&balance=' + data.balance, data, {
    headers: authHeader(),
  });
};

const getCustomerBal = (data) => {
  return axios.get(API_URLU + "customer-balance?cmpId=" + data.cmpId + '&subaccountCode=' + data.subaccountCode, {
    headers: authHeader(),
  });
};

const getCustomerstm = (data) => {
  return axios.get(API_URLU + "customer-statement?cmpId=" + data.cmpId + '&sshId=' + data.sshId, {
    headers: authHeader(),
  });
};

const getBusinessLines = () => {
  return axios.get(API_URLU + "business-lines", { headers: authHeader() });
};

const getBankOpenTransByAccCode = (data) => {
  return axios.get(API_URLU + "bank-open-trans-det-acc?cmpId=" + data.cmpId + "&accountCode=" + data.accountCode + '&startDate=' + data.startDate + '&endDate=' + data.endDate, {
    headers: authHeader(),
  });
};

const removeOpenTrans = (id) => {
  return axios.delete(API_URLU + "cfs-delete-open-trans?otrId=" + id, { headers: authHeader() });
};

const getAllServiceForSale = (data) => {
  return axios.get(API_URLU + "all-services-for-sale?cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const getAllStockForSale = (data) => {
  return axios.get(API_URLU + "all-stocks-for-sale?cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const getAllSalesForReceiptsByCmpId = (cmpId) => {
  return axios.get(API_URLU + "all-sales-cmpId/" + cmpId, {
    headers: authHeader(),
  });
};

const getAllSalesByCustCodeAndCmpId = (data) => {
  return axios.get(API_URLU + "all-sales-per-customer?cmpId=" + data.cmpId + '&custCode=' + data.custCode, {
    headers: authHeader(),
  });
};

const getCreditNoteHeaders = (data) => {
  return axios.get(API_URLU + "cfs-credit-note?cmpId=" + data.cmpId, {
    headers: authHeader(),
  });
};

const getCreditNoteDetails = (data) => {
  return axios.get(API_URLU + "cfs-credit-note-details?cnhId=" + data.cnhId, {
    headers: authHeader(),
  });
};

const postCNHeaders = (data) => {
  return axios.post(API_URLU + "cfs-credit-note", data, {
    headers: authHeader(),
  });
};

const postCNDetails = (data) => {
  return axios.post(API_URLU + "cfs-credit-note-details", data, {
    headers: authHeader(),
  });
};

const putCNHeaders = (data) => {
  return axios.put(API_URLU + "cfs-credit-note?cnhId=" + data.cnhId, data, {
    headers: authHeader(),
  });
};

const putCNDetails = (data) => {
  return axios.put(API_URLU + "cfs-credit-note-details?cndId=" + data.cndId, data, {
    headers: authHeader(),
  });
};

const postCfsSaleFinTrans2 = (data) => {
  return axios.get(
    API_URLU +
    "approve-cfs-stock-sale2?sshId=" +
    data.sshId +
    "&cnhId=" +
    data.cnhId +
    "&cmpId=" +
    data.cmpId +
    "&user=" +
    data.user,
    { headers: authHeader() }
  );
};

const deleteInsertedTrans = (data) => {
  return axios.get(
    API_URLU +
    "delete-cfs-inserted-records?sshId=" +
    data.sshId +
    "&athId=" +
    data.athId +
    "&cmpId=" +
    data.cmpId,
    { headers: authHeader() }
  );
};

const LinkNewMenuItems = (data) => {
  return axios.get(
    API_URLU +
    "link-new-db-menu?cmpId=" +
    data.cmpId +
    "&userId=" + data.userId +
    "&username=" +
    data.username,
    { headers: authHeader() }
  );
};

const getAllGlSalesBySshId = (sshId) => {
  return axios.get(API_URLU + "gl-sale-tran-dets?sshId=" + sshId, {
    headers: authHeader(),
  });
};

const getCustomRptFormat = (data) => {
  return axios.get(
    API_URLU +
    "custom-format_report?mngRptFormatId=" +
    data.mngRptFormatId +
    "&firstDate=" + data.firstDate +
    "&lastDate=" +
    data.lastDate + 
    "&accYear=" +
    data.accYear,
    { headers: authHeader() }
  );
}

const deleteMainAccountGroup = (grpId) => {
  return axios.delete(API_URLU + "account-groups/" + grpId, {
    headers: authHeader(),
  });
};

export default {
  getUserById,
  getPendingSales,
  postSale,
  delSale,
  putSale,
  getSalesByDate,
  getSalesByShop,
  getUserShops,
  getDaySales,
  getUserSales,
  getAllSales,
  getUsers,
  postUser,
  getCompById,
  getCompanies,
  postComp,
  getSystemById,
  getSystems,
  postSystem,
  postUserComp,
  postUserSystems,
  getUserComp,
  getCompSystems,
  getUserCompSystems,
  getUserCompUSystems,
  getCustomerById,
  getCustomers,
  postCustomer,
  putCustomer,
  getEmployeeById,
  getEmployeeByUsername,
  getEmployees,
  getPagedEmployees,
  postEmployee,
  putEmployee,
  getClassification,
  getGeneral,
  getFiles,
  saveInvoice,
  getInvoiceInfo,
  getScheduledLeaves,
  postLeaveSchedule,
  getLeaveAccruals,
  getLeaveApplications,
  postLeaveApplication,
  getLeaveTransactions,
  getLeaveRejections,
  getLeaveTypes,
  getReturnDate,
  uploadFile,
  uploadExcel,
  postTempBranch,
  getTempBranch,
  getPastDays,
  postDay,
  getDaysStatus,
  putDay,
  getMaxDate,
  getSaleStatus,
  updatePass,
  updateUser,
  updateUserImg,
  getApprovedSales,
  getAdminSalesByDate,
  getAllShops,
  getAdminSalesByShop,
  getStockCodes,
  getQuoteId,
  getQuoteInfo,
  delQuote,
  getQuoteReport,
  postQuoteHeader,
  postQuoteDetails,
  genCombinedQuote,
  getCombinedQuotes,
  archCombQuote,
  listSingleQuoutes,
  listCombinedQuoutes,
  companyVatRates,
  checkVatDates,
  postVatRates,
  delVatRate,
  putVatRate,
  companyStdRates,
  postStandardRates,
  delStdRate,
  putStdRate,
  companyGenRates,
  postGeneralRates,
  delGenRate,
  putGenRate,
  currentPeriods,
  pastPeriods,
  closePeriod,
  postNewPeriod,
  putIstPeriod,
  getCompanyProducts,
  getProductDetails,
  postIstProducts,
  putIstProducts,
  delIstProduct,
  getCompanySuppliers,
  getSupplierDetails,
  postIstSuppliers,
  putIstSuppliers,
  getSupplierStocks,
  getSupplerProductDetails,
  putIstSupplierProducts,
  getCombinedSingle,
  updateStockQuote,
  postIstSupplierProducts,
  getCompanyTariffPeriods,
  getTariffCashRates,
  getRateDetails,
  putCashRateDetails,
  getCheckOffMarkupPercs,
  getMarkupPercDetails,
  putMarkupDetails,
  closeTariffPeriod,
  getTrpHpDeposit,
  getHPDepositDetails,
  putHpDepositDetails,
  getTrpDiscounts,
  getDiscountDetails,
  putDiscountDetails,
  getTrpInstalMonths,
  getInstalMonthsDetails,
  putInstalMonths,
  getHpMarkupRates,
  getMarkupDetails,
  putMarkupRates,
  getHpMarkupPercs,
  getMarkupPerc,
  putMarkupPercs,
  copyPeriods,
  getProductHist,
  getCompanyStocks,
  postCashRateDetails,
  delCashRate,
  postMarkupDetails,
  delMarkup,
  postHpDepositDetails,
  delHpDepositDetails,
  postDiscountDetails,
  delDiscountDetails,
  postInstalMonths,
  delInstalMonths,
  postMarkupRates,
  delMarkupRate,
  getPriceCataloq,
  getJointYn,
  getJointStockCodes,
  getStockCatalogue,
  getActiveStocks,
  getMinDate,
  getStockCheckOff,
  getSupplierPriceList,
  getSupplierPastPriceList,
  updatePriceCatalogue,
  addNewPriceListItem,
  updatePriceList,
  UpdateAllPrices,
  getJointStocks,
  addJointStocks,
  getUserRights,
  approveVATRates,
  approveSTDRates,
  approveGENRates,
  approvePeriod,
  allPeriods,
  clearStockPrices,
  updateStockPrices,
  updateTariffPeriod,
  approvetariffPeriod,
  getCataloguePeriods,
  inteGrateWithKct,
  getCompanyStockCodes,
  genNoneStockQuote,
  listNonStockQuotes,
  approveCashRate,
  approveCheckOff,
  getActiveEndDate,
  approveStock,
  getMenuLevels,
  getAddTempItem,
  getPoH,
  getPoHVW,
  getReqH,
  getPoD,
  getReqD,
  getPolNo,
  postPoH,
  postPoD,
  getReqSummary,
  getPoSummary,
  getPohApproval,
  getPurchaseReport,
  getCustomerByCmpId,
  genCombQuoteHeader,
  genCombNoneStockQuote,
  listCombNonStockQuotes,
  getCombQuoteReport,
  postGaaH,
  postGaaD,
  getUpdatePoDetails,
  getPoNotInGaa,
  getGaaHVW,
  getGaaHVWItems,
  getUserBranches,
  generateCombinedNonStockQuote,
  genCombQuoteNoneStockDetails,
  postGap,
  postStkTransH,
  postStkTransD,
  getShopTransfers,
  getShopTransferDetails,
  getTransferInvoiceReport,
  getSupplierEmail,
  sendLpoMail,
  getReceiptTranCodes,
  getPaymentModes,
  getCustomerCodes,
  getPolicyInformation,
  getAddress,
  getAllBankAccounts,
  getDocDetails,
  docAvailable,
  postReceiptHeader,
  putReceiptHeader,
  postReceiptDetails,
  putReceiptDetails,
  getReceiptDetails,
  getCompanyBanks,
  getReceiptHeaderApprovalStatus,
  approveReceiptHeader,
  saleItems,
  postSalesHeader,
  postSalesDetails,
  postSalesParticular,
  getSalesHeader,
  getCustomerByCmpIdAndId,
  getGapItemsByGaaNo,
  poReports,
  getPoReportDetails,
  getPurchaseReport2,
  updateMialSent,
  cancelPO,
  getSaleTypes,
  companyReceipts,
  getSelectedReceiptDetails,
  getAllCreditAccounts,
  getPaymentHeaders,
  getPaymentDetailsByHeaderId,
  getInvoiceTransactionCodes,
  getPaymentTransactionCodes,
  getInvoiceHeaders,
  getOurRef,
  getMainAccounts,
  getSubAccountsByMain,
  getCustBank,
  getBranches,
  getDepartments,
  postPaymentDetails,
  postPaymentHeaders,
  putPaymentHeaders,
  getPaymentHeaderByHeaderId,
  postGltranHeaders,
  postGltranDetails,
  getPaymentReport,
  getPaymentDetails,
  getAllPaymentHeaders,
  approvePaymentHeader,
  getPaymentDocNumber,
  getInvoiceBalance,
  findPaymentModes,
  getTranTypes,
  linkCustomerAccount,
  getLinkedCustomerAccounts,
  getUnbankedReceipts,
  getCustomerSubaccounts,
  generateCustomerSubaccount,
  getBankingTranCode,
  getBankingDocNumber,
  postReceiptBankHeader,
  postReceiptBankDetails,
  getGaaDByGaaNo,
  getSaleFinTrans,
  genSaleFinTrans,
  getSalesDetailsBySshId,
  getSalesParticularBySshId,
  getSaleInformation,
  deleteReceiptDetail,
  postPoEmails,
  getEmailedPoLPOs,
  getSupplierEmails,
  postSupplierEmails,
  putSupplierEmails,
  delSupplierEmails,
  getCompanyBranches,
  putCompany,
  getBranch,
  putBranch,
  postBranch,
  postHpAccount,
  postHpAccountGuarantor,
  getHpAccountHist,
  getHpAccountGuarantorHist,
  getHpAccByCustCode,
  getCertReport,
  getHpAccByHpNo,
  getHpGuarantorsHistByHpNo,
  getHpAllAttachments,
  getHpAccByCmpId,
  getHPSalesHeader,
  getHPPreSalesHeader,
  getHpAccGuarantors,
  genHPSchedule,
  getHPSchedule,
  postHpDocs,
  getHpDocs,
  approveAndGenHpFin,
  autoAllocReceipt,
  printReceipt,
  getAmountToWords,
  autoGenerateReceipt,
  getReceiptHeader,
  getOriginalSaleReceipt,
  getSuspBal,
  getPoReportDetailsByPhd,
  postReceiptSaleInfo,
  postSaleFinGL,
  deletePaymentDetails,
  getHpReceipts,
  printHpStatement,
  getCompanyUserBranches,
  getUnApprovedHanded,
  postHandedReceipts,
  putHandedReceipts,
  fetchHandedReceiptDetails,
  postHandedReceiptDetails,
  putHandedReceiptDetails,
  saveHeaderHdoId,
  handOverForBanking,
  updateHandedDetails,
  getUnapprovedBatches,
  getApprovedBatches,
  getBankedReceipts,
  uploadBankReceipt,
  postReceiptBanking,
  putReceiptBankHeader,
  poStocksForRejection,
  transferStocksForRejection,
  postRejectPos,
  putRejectPos,
  getRejectedGaas,
  updateRejectedGaas,
  getRejectedPoGaas,
  getStockDescription,
  getCLientIdNumber,
  getDefaultAccounts,
  postPaymentParticulars,
  getPoHBalnce,
  getActiveHPAccounts,
  getHpAccGuarantorsByCustCode,
  getStockAdjustmentHeaders,
  postStockAdjustmentHeaders,
  putStockAdjustmentHeaders,
  getStockAdjustmentDetails,
  postStockAdjustmentDetails,
  putStockAdjustmentDetails,
  getCustomerSaleItems,
  insertAdjustmentDetails,
  getStockAdjustmentsByStatus,
  genGlAdjustments,
  getGlTransView,
  getGlTransViewId,
  getCustomerAttachments,
  postCustomerAttachments,
  getGapByGaadNo,
  getHPSalesHeaderSearch,
  getHPSalesHeaderNew,
  getHPSalesHeaderSearchNew,
  getGeneralCodes,
  postGeneralCodes,
  putGeneralCodes,
  getAttachedMenuItems,
  getAvailableCodes,
  postMainMenu,
  getAttachedGoneItems,
  getAvailableMenuAccessCodes,
  postGoneMenu,
  getAttachedGtwoItems,
  getAvailableGoneAccessCodes,
  postGtwoMenu,
  getAttachedGthreeItems,
  getAvailableGtwoAccessCodes,
  postGthreeMenu,
  getAllMenuDeleteStatus,
  deleteSystem,
  deleteSystemMenus,
  deleteGroupOneItems,
  deleteGroupTwoItems,
  deleteGroupThreeItems,
  getAssignedRoleDeleteStatus,
  deleteMainMenu,
  deleteGoneMenu,
  deleteGtwoMenu,
  deleteGthreeMenu,
  approveAdjustments,
  getAllocatedForBanking,
  getVerifiedBatches,
  getBankedFinTrans,
  getPendingTempReceipts,
  getApprovedTempReceipts,
  getTempRctBalances,
  getTempRctDetails,
  postTempReceiptHeaders,
  putTempReceiptHeaders,
  postTempReceiptDetails,
  putTempReceiptDetails,
  deleteTempReceiptDetails,
  getSupplierDetailsByCmp,
  getTemCustHPs,
  approveCancelTempReceipt,
  getPendingUtilization,
  getTemporaryReceiptBalances,
  getApprovedUtilization,
  generateSuspenseReceipt,
  finalSuspenseReceiptUpdate,
  getReceiptedTempReceipts,
  getTempReceipts,
  printTemporaryReceipt,
  getCustomerHist,
  getCustomerByCmpIdAndNid,
  postSafari,
  postSafariDetails,
  getSafariByCmpId,
  getSafariDetailsByHpsId,
  getPeriodDaysByCmpId,
  getAmortHeaderByCmpId,
  getAmortDetailsByAmhId,
  genHpAmortization,
  updateSafari,
  updateSafariDetails,
  approveHpAmortization,
  getCheckOffMonthsByCmpId,
  getPoReportDetailsRange,
  getJournalsByCmpIdAndId,
  getJournalsByCmpId,
  getJournalDetailsByHeaders,
  getJournalTransactionCodes,
  postJournalHeaders,
  postJournalDetails,
  deleteJournalDetail,
  getJournalHeadersById,
  getJournalDetailsById,
  putJournalDetails,
  putJournalHeaders,
  approveJournalHeader,
  getMainAccountsByCmpId,
  reverseGlTransaction,
  getJournalVoucher,
  getJournalRepDetailsByHeaders,
  getBankReconciliationBanks,
  getBankStatementDetailsByHeaderId,
  getBankStatementsHeadersByAccountCodeCmpId,
  getBankRecTransactionCodes,
  postBankRecHeaders,
  postBankRecDetails,
  putBankRecHeaders,
  putBankRecDetails,
  getBankRecHeadersById,
  getBankRecDetailsById,
  uploadBankStatementDetails,
  approveBankUpload,
  declineBankUpload,
  getAllglTransactions,
  getAllBankOpenTransCmpId,
  getAllBankOpenTransCmpIdandDocNumber,
  getGlTransViewCmpId,
  getGlTransViewCmpIdandDocNumber,
  getBankOpenTransByDetailId,
  saleItems2,
  getPaymentParticularByHeaderId,
  saleItems3,
  updateTranDetails,
  hpBalance,
  getHpDiscounts,
  finalTempReceiptUtilization,
  getBranchTempBal,
  getHPDetails,
  getStockReports,
  runStocksReport,
  getUnutilizedMpesa,
  getBranchUsers,
  getSafariDesc,
  postSafariSalesmen,
  getSafariSalesmenByHpsId,
  updateSafariAdvanceReceived,
  updateFeedbackAccepted,
  getHpSafariReport,
  runHpSafariReport,
  getPettyCashTrSusp,
  postPettyCashTrSusp,
  putPettyCashTrSusp,
  updatePettyCash,
  finalPettyCashUpdate,
  getApprovedCancelledPettyCash,
  getPendingExpenses,
  getPettyCashBal,
  postPettyCashExpenses,
  putPettyCashExpenses,
  getPendingBranchExpenses,
  getApprovedCancelledExpenses,
  getPettyCashByExpId,
  getRecoverableAmounts,
  getPendingCustTemps,
  getApprovedCustTemps,
  postCustTempOuts,
  putCustTempOuts,
  getPettyCashCustTemps,
  getCustTempBal,
  getCfsMainAccounts,
  postCfsMainAccounts,
  putCfsMainAccounts,
  getCfsMainSubAccountsbyAccountCode,
  getCfsMainAccountsById,
  getCfsMainSubAccountsById,
  postCfsMainSubAccounts,
  putCfsMainSubAccounts,
  getCfsAccountYearsByCmpid,
  getCfsAccountBudgetsByCmpidandYear,
  getCfsBranchBudgetsByCmpidandYear,
  getCfsDeptBudgetsByCmpidYearandBranch,
  getFrozenCfsMainAccounts,
  getAllCfsMainAccounts,
  getBankHeadersBySacco,
  getActiveBankHeadersBySacco,
  postBankHeaders,
  putBankHeaders,
  getBankHeadersById,
  delBankHeaders,
  getBankBranchesBySacco,
  postBankBranches,
  putBankBranches,
  getBankBranchesById,
  getBankBranchesByHeader,
  getActBankBranchesByHeader,
  getBankBranchesByCmpId,
  delBankBranches,
  getMainSubAccountsBySubAccountCode,
  getSubAccountsByCmpId,
  postSubAccounts,
  postMainSubAccounts,
  putSubAccounts,
  getSubAccountsById,
  getInsurerCustomersByCmpId,
  getCustomersToCreateSubAccount,
  getAccountsToLinkBySubaccountCode,
  getSubAccountsToLinkByAccountCode,
  getReceiptHeadersByCmpid,
  getReceiptDetailsByHeaderId,
  findPaymentModesByCmpId,
  findReceiptTransactionCodes,
  getCashBankMainAccounts,
  getAssetMainAccountsSubAccounts,
  linkCmpMenus,
  getBranchesByCmpId,
  getInvoicesWithBalanceForPayment,
  postPaymentInvoices,
  getInvoicesPaidByPayment,
  getJournalReport,
  getPaymentVoucher,
  getReceipt,
  getAccountReports,
  runAccountsReport,
  getTrialBalanceReport,
  getGlActivityReport,
  getAllTranCodes,
  postTranCode,
  updateTranCode,
  getAllTranPrivs,
  postTranPrivs,
  updateTranPrivs,
  getMainCategories,
  getCategories,
  getAssetDefinition,
  postMainCategories,
  updatetMainCategories,
  postCategories,
  updatetCategories,
  postItemDef,
  updateItemDef,
  getCompanySystemUsers,
  getCfsCompanyBanks,
  postCfsCompanyBanks,
  updateCfsCompanyBanks,
  getCfsCompanyBankChqDetails,
  getCfsCompanyBankChqDetailsById,
  getCurrency,
  postCfsCompanyBankCheque,
  updateCfsCompanyBankCheque,
  getAccountsUserComp,
  companySystemLink,
  adminSystemLink,
  companyMenuLink,
  getJournalListingReport,
  getPaymentListingReport,
  getReceiptListingReport,
  updatebankBranchCode,
  getTransactionPrivsByCmpIdAndTranCodeAndUserName,
  getControlAccountsByCmpId,
  postControlAccounts,
  putControlAccounts,
  getAccountPeriodsByCmpIdandCalendarYear,
  getAccountPeriodsByCmpIdandCalendarYearandCalendarMonth,
  putAccountBudgets,
  postAccountBudgets,
  putPeriodMonths,
  postPeriodMonths,
  putPeriodYears,
  postPeriodYears,
  getAccountYearsById,
  getAccountPeriodMonthsById,
  getAccountBudgetsById,
  getAccBranchBudgetsByAccountYearandMonth,
  getAccBudgetsByCmpIdandYearandAccountCode,
  getAccDeptBudgetsByYearAndMonthAccountAndBranch,
  getItemParticular,
  postItemParticular,
  updateItemParticular,
  getGeneralParamsCmpid,
  postGeneralParams,
  getGeneralParamsById,
  updateGeneralParams,
  postAccountRepHeaders,
  getAccountRepheadersCmpid,
  getAccountRepHeadersById,
  updateAccountRepHeaders,
  postAccountRepDetails,
  getAccountRepDetailsHeaderId,
  getAccountRepDetailsById,
  updateAccountRepDetails,
  postAccountRepAggregates,
  getAccountRepAggregatesHeaderId,
  updateAccountRepAggreagates,
  getAccountRepAggregatesById,
  postAccountReports,
  getAccountReportsCmpid,
  getAccountReportsById,
  updateAccountReports,
  getAccountRepAggreagatesByHeaderDetails,
  getAccountRepDetailsByHeaderDetails,
  getAccountRepheadersParamcode,
  getCustTypeByCmpId,
  getClientTypeByCmpId,
  getIdentificationTypeByCmpId,
  getOccupationCodesByCmpId,
  getOnluserInsurerCustomersByCmpId,
  getUsersPermittedForCustomers,
  getCompanyCustomerCode,
  postOnlineCredential,
  getPermittedCustomerById,
  putOnlineCredential,
  postTranSerials,
  postAccountGroups,
  updateAccountGroups,
  getAccountGroupsById,
  getAccountGroupsByCmpId,
  getMainAccountWithGroupsByCmpId,
  getFrozenMainAccountWithGroupsByCmpId,
  putUser,
  getMainAccountsReport,
  updateDepartments,
  postDepartments,
  getDepartmentsByCmpId,
  getDepartmentsById,
  updateCostCenters,
  postCostCenters,
  getCostCentersByCmpId,
  getCostCentersById,
  generateCompanySerials,
  getActiveCurrency,
  getTranSerialsByCmpId,
  getAllTranSerials,
  updateTranSerials,
  getCustClassificationByCmpId,
  getDiscountCategoryByCmpId,
  getAllCompanySuppliers,
  delinkSubAccount,
  deleteMainAccount,
  getMainSubAccountsReport,
  getAllCustomersByCmpId,
  getPendingSaleHeadersByCmpId,
  getProcessedSaleHeadersByCmpId,
  postSaleHeaders,
  updateSaleHeaders,
  getSaleHeadersById,
  getSalesDetailsByHeaderId,
  postSaleDetails,
  updateSaleDetails,
  getSaleDetailsById,
  getAssetsByCmpId,
  getAssetUnitsByCmpId,
  getAssetDefinitionByCmpId,
  getInvoiceReport,
  findSaleTransactionCodes,
  postSaleFinTrans,
  getSalesFinTransByHeaderId,
  updateSaleFinTrans,
  getSaleFinTransById,
  postCfsSaleFinTrans,
  getDeclinedSaleHeadersByCmpId,
  getCustomerSalesForReceiptsByCmpId,
  getWalkinSalesForReceiptsByCmpId,
  getReceiptGlTransactionDetailsByHeaderId,
  getPaymentGlTransactionDetailsByHeaderId,
  getJournalGlTransactionDetailsByHeaderId,
  getCompanyClassifiedCustomerCode,
  postAssetUnit,
  updateAssetUnit,
  getSalesReportsBySshId,
  findOtherTransactionCodes,
  fetchAllUnbankedReceipts,
  fetchFilteredUnbankedReceipts,
  fetchApprovedReceiptBankingHeaders,
  fetchPendingReceiptBankingHeaders,
  fetchDeclinedReceiptBankingHeaders,
  fetchBankingDetailsByHeaders,
  putReceiptBankDetails,
  fetchAllReceiptBankingHeaders,
  getPaymentsonSelectedInvoice,
  getPoDetails,
  getGeneralCodeByCmpId,
  getBankedReceiptDetailsByHeaderId,
  approveReceiptBanking,
  getReceiptBankingGlTransactionDetailsByHeaderId,
  postAssetTranHeaders,
  updateAssetTranHeaders,
  deleteAssetTranHeaders,
  postAssetTranDetails,
  updateAssetTranDetails,
  deleteAssetTranDetails,
  getEndYearJournalsByCmpId,
  generateEndYearJournalBrief,
  clearOrPurgeEndYearJournalBrief,
  declineCfsSaleHeader,
  getActiveAssetUnitsByCmpId,
  getDebtorsAgedListingReport,
  getStatementOfAccountsReport,
  getStockPriceListByStockCode,
  postIstStockPrices,
  updateIstStockPrices,
  getStockPriceListByCmpid,
  duplicateIstStockPrices,
  getStocksForSaleByCmpId,
  getCfsReportcategories,
  getCfsReportsByCatId,
  getApprovedStockReqHeadersByCmpId,
  getPendingStockReqHeadersByCmpId,
  getDeclinedStockReqHeadersByCmpId,
  postReqHeaders,
  postReqDetails,
  getReqHeadersById,
  getReqDetailsByHeaderId,
  updateReqHeaders,
  updateReqDetails,
  getItemsForRequisitionByCmpId,
  getIssuedStockReqHeadersByCmpId,
  getCategoriesCmpid,
  getAssetDefinitionByCategory,
  getBatchesByLotId,
  getInternalTransactionCodes,
  postIstStockReqFinTrans,
  getCurrentActivePriceByStockCode,
  tenantPost,
  findBankStatUploadCodes,
  postBankStatHeaders,
  postBankStatDetails,
  putBankStatHeaders,
  putBankStatDetails,
  getBankStatHeadersByCmpId,
  getBankStatDetailsByHeaderId,
  uploadBankStatDetails,
  getApproveBankRec,
  getBankDbAutomatch,
  saveCsvData,
  getApprovalRights,
  clearUploadDetails,
  runBankrecReport,
  getBankTtlAlloc,
  getBankOpenTransByAccCodeFlag,
  postSingleMatch,
  getTenants,
  getServiceForSaleByCmpId,
  getAllCategories,
  getLinkedCustomers,
  getAssetServices,
  postAssetServices,
  updateAssetServices,
  getStatementReport,
  getCustomerBal,
  getCustomerstm,
  setTenants,
  getBusinessLines,
  getBankOpenTransByAccCode,
  removeOpenTrans,
  getAllServiceForSale,
  getAllStockForSale,
  findCreditNoteTransactionCodes,
  getAllSalesForReceiptsByCmpId,
  postCNHeaders,
  postCNDetails,
  putCNHeaders,
  putCNDetails,
  getCreditNoteHeaders,
  getCreditNoteDetails,
  getSalesFinTransBySshId,
  postCfsSaleFinTrans2,
  deleteInsertedTrans,
  getAllSalesByCustCodeAndCmpId,
  LinkNewMenuItems,
  getAllGlSalesBySshId,
  getCustomRptFormat,
  deleteMainAccountGroup
};
